(async () => {
'use strict';
/* ---------- Shopify data ---------- */
const BT = window.BT || {};
const PASS = (() => { // keep theme-preview parameters on the app's own requests (admin preview of a password-protected store)
  const q = new URLSearchParams(location.search);
  ['page', 'view', 'q', 'sort_by'].forEach(k => q.delete(k));
  return q.toString() ? '&' + q : '';
})();
function blockedByPassword(r) { return r.redirected && /\/password/.test(r.url); }
async function loadCatalog() {
  const key = 'bt:cat:' + (BT.v || '');
  try { const c = JSON.parse(sessionStorage.getItem(key) || 'null'); if (c && Date.now() - c.t < 10 * 60 * 1000) return c.d; } catch { /* no cache */ }
  const specsP = BT.specs ? fetch(BT.specs).then(r => r.ok ? r.json() : {}).catch(() => ({})) : Promise.resolve({});
  const all = [];
  const pageCount = Math.min(19, Math.ceil((+BT.n || 0) / 250));
  if (pageCount > 1) { // parallel; falls back to one-by-one below when the count is missing
    const lists = await Promise.all(Array.from({ length: pageCount }, (_, i) => loadCatalogPage(i + 1)));
    lists.forEach(rows => all.push(...rows));
  } else for (let page = 1; page < 20; page++) {
    const rows = await loadCatalogPage(page);
    all.push(...rows);
    if (rows.length < 250) break;
  }
  const specs = await specsP;
  for (const x of all) if (!x.s && specs[x.h]) x.s = specs[x.h];
  try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: all })); } catch { /* full */ }
  return all;
}
async function loadCatalogPage(page) {
  {
    const r = await fetch(`${BT.data}&page=${page}${PASS}`, { credentials: 'same-origin' });
    if (blockedByPassword(r)) throw new Error('password');
    if (!r.ok) throw new Error(r.status);
    const txt = await r.text();
    let rows;
    try { rows = JSON.parse(txt); } catch { throw new Error(`catalog page ${page} is not JSON: ${txt.slice(0, 160)}`); }
    return rows;
  }
}
const TAGV = (tags, pre) => { const t = tags.find(x => x.startsWith(pre)); return t ? t.slice(pre.length) : undefined; };
function specFromTags(x) { // products added later in Shopify admin without the specs field
  const tags = x.tags || [], num = v => v == null ? undefined : +v;
  const c = tags.includes('Trailers') ? 't' : 'c', g = TAGV(tags, 'group:') || (c === 't' ? 'cargo' : 'other');
  return { c, g, st: x.t, cond: TAGV(tags, 'cond:'), L: num(TAGV(tags, 'len:')), W: num(TAGV(tags, 'width:')), hc: tags.includes('High cube') ? 1 : undefined,
    nose: TAGV(tags, 'nose:'), col: TAGV(tags, 'color:'), axn: num(TAGV(tags, 'axles:')), f: tags.filter(t => t.startsWith('feat:')).map(t => t.slice(5)), u: c === 't' ? [g] : [] };
}
function toUnit(x) {
  const p = Object.assign({}, x.s || specFromTags(x));
  p.id = p.id || x.pid; p.h = x.h; p.v = x.v; p.p = +x.p; p.cp = +x.cp > +x.p ? +x.cp : 0; p.sku = x.sku || ''; p.t = x.t; p.st = p.st || x.t;
  p.seo = x.seo || ''; p.im = x.im || []; p.n = p.im.length; p.ar = +x.ar || 1.33; p.av = x.av !== false;
  return p;
}
function imgSrc(p, k = 0, w = 600) { const u = p.im[k]; if (!u) return ''; return /[?&]width=\d+/.test(u) ? u.replace(/([?&]width=)\d+/, '$1' + w) : u + (u.includes('?') ? '&' : '?') + 'width=' + w; }
let CAT_RAW = [];
try { CAT_RAW = await loadCatalog(); } catch (e) { console.error('Boxtrail: catalog could not be loaded', e); document.body.dataset.btError = String(e && e.message || e).slice(0, 200); document.body.removeAttribute('data-spa');
  const v = document.getElementById('view');
  if (v) v.insertAdjacentHTML('afterbegin', e && e.message === 'password'
    ? '<p class="bt-err wrap">Store preview: the store password blocks the product data, so this is the simple version of the page. Remove the password (Online Store › Preferences) or open the theme preview from Shopify admin to see the full store.</p>'
    : `<p class="bt-err wrap">Some parts of the store could not load. Refresh the page. <small>(${String(e && e.message || e).replace(/[<>&]/g, '').slice(0, 160)})</small></p>`);
}


/* ---------- store settings (edit these) ---------- */
const CONFIG = { brand: 'Boxtrail', company: 'TRAIL LLC', street: '14045 Abercorn St', city: 'Savannah, GA 31419', phone: '+1 (202) 991-0008', whatsapp: '12029910008', email: BT.email || 'sales@example.com' };
const ADDRESS = `${CONFIG.street}, ${CONFIG.city}`;
const MAP_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ADDRESS)}`;

/* ---------- data ---------- */
const CAT = CAT_RAW.map(toUnit).sort((a, b) => a.p - b.p);
CAT.forEach((p, i) => { p.r = i; p.u = p.u || []; p.f = p.f || []; });
const BY = new Map(CAT.map(p => [p.id, p]));

const CGROUPS = { storage: 'Storage containers', cold: 'Refrigerated containers', office: 'Offices & site cabins', business: 'Bars, cafés & kiosks', welfare: 'Toilets & welfare units', hazmat: 'Hazmat & secure stores', pool: 'Container pools', flatpack: 'Flat-pack stores', other: 'Specialty units' };
const TGROUPS = { cargo: 'Cargo & equipment trailers', car: 'Car haulers', moto: 'Motorcycle & ATV trailers', lawn: 'Landscaping trailers', event: 'Event & mobile business trailers' };
const USES = { cargo: 'Cargo & equipment', car: 'Cars', moto: 'Motorcycles & ATVs', lawn: 'Landscaping', event: 'Events & mobile business' };
const CFEAT = { hc: 'High cube (9 ft 6 in tall)', rollup: 'Roll-up door', side: 'Side access doors', double: 'Doors at both ends', mandoor: 'Personnel door', insulated: 'Insulated', power: 'Power & lighting', windows: 'Windows', hvac: 'Heating / A/C', opentop: 'Open top / flat rack', cargoworthy: 'Cargo-worthy', watertight: 'Wind & watertight' };
const TFEAT = { blackout: 'Blackout package', electrical: 'Electrical package', ramp: 'Ramp door', barn: 'Barn doors', sidedoor: 'Side door', escape: 'Escape door', etrack: 'E-track', floor: 'Upgraded floor', windows: 'Windows', hybrid: 'Hybrid deck or gate', racks: 'Ladder racks / rails', brakes: 'Brakes', ac: 'A/C', cabinets: 'Cabinets', slant: 'Slant top', winch: 'Winch' };
const COLORS = { Black: '#1d1f22', White: '#f4f5f6', Charcoal: '#4b5058', Silver: '#b8bdc4', Red: '#b3261e', Blue: '#2e4f9e', Green: '#6aa335', Yellow: '#e2b416', 'Two-tone': 'linear-gradient(135deg,#b3261e 50%,#1d1f22 50%)' };
const NEEDS = {
  store:   { label: 'Store tools, stock or equipment', icon: 'box',     test: p => p.c === 'c' && (p.g === 'storage' || p.g === 'flatpack') },
  office:  { label: 'Set up a site office or welfare unit', icon: 'office', test: p => p.c === 'c' && (p.g === 'office' || p.g === 'welfare') },
  cold:    { label: 'Keep products cold', icon: 'snow',    test: p => p.g === 'cold' },
  biz:     { label: 'Open a bar, café or pop-up', icon: 'store', test: p => p.g === 'business' || (p.c === 't' && p.u.includes('event')) },
  vehicle: { label: 'Haul cars, bikes or ATVs', icon: 'trailer', test: p => p.c === 't' && (p.u.includes('car') || p.u.includes('moto')) },
  gear:    { label: 'Haul tools and equipment', icon: 'wrench',  test: p => p.c === 't' && (p.u.includes('cargo') || p.u.includes('lawn')) },
};
const groupLabel = p => (p.c === 'c' ? CGROUPS : TGROUPS)[p.g] || '';
const catLabel = c => c === 'c' ? 'Containers' : c === 't' ? 'Enclosed trailers' : 'All units';

/* ---------- facets ---------- */
const between = (a, b) => p => p.L >= a && p.L <= b;
const PRICE = {
  all: [['u1', 'Under $1,000', p => p.p < 1000], ['1-3', '$1,000–3,000', p => p.p >= 1000 && p.p < 3000], ['3-6', '$3,000–6,000', p => p.p >= 3000 && p.p < 6000], ['6+', '$6,000 and up', p => p.p >= 6000]],
  c: [['u1', 'Under $1,000', p => p.p < 1000], ['1-2.5', '$1,000–2,500', p => p.p >= 1000 && p.p < 2500], ['2.5-5', '$2,500–5,000', p => p.p >= 2500 && p.p < 5000], ['5+', '$5,000 and up', p => p.p >= 5000]],
  t: [['u3', 'Under $3,000', p => p.p < 3000], ['3-5', '$3,000–5,000', p => p.p >= 3000 && p.p < 5000], ['5-8', '$5,000–8,000', p => p.p >= 5000 && p.p < 8000], ['8+', '$8,000 and up', p => p.p >= 8000]],
};
const FACETS = [
  { key: 'job', label: 'What it’s for', cats: ['all', 'c', 't'], kind: 'checks', opts: Object.entries(NEEDS).map(([k, n]) => [k, n.label, n.test]) },
  { key: 'group', label: 'Type', cats: ['c'], kind: 'checks', opts: Object.entries(CGROUPS).map(([k, l]) => [k, l, p => p.g === k]) },
  { key: 'use', label: 'Built for', cats: ['t'], kind: 'checks', opts: Object.entries(USES).map(([k, l]) => [k, l, p => p.u.includes(k)]) },
  { key: 'clen', label: 'Length', cats: ['c'], kind: 'chips', opts: [['u10', 'Under 10 ft', p => p.L < 10], ['10', '10 ft', between(10, 11)], ['12', '12–16 ft', between(12, 16)], ['20', '20 ft', between(17, 21)], ['24', '24–32 ft', between(22, 32)], ['40', '40 ft', p => p.L === 40], ['45', '45 ft', p => p.L === 45], ['53', '53 ft', p => p.L === 53]] },
  { key: 'tw', label: 'Width', cats: ['t'], kind: 'chips', opts: [['6', '6 ft', p => p.W === 6], ['7', '7 ft', p => p.W === 7], ['8.5', '8.5 ft', p => p.W === 8.5]] },
  { key: 'tlen', label: 'Length', cats: ['t'], kind: 'chips', opts: [['12', '12 ft or less', p => p.L <= 12], ['14', '14–16 ft', between(13, 16)], ['18', '18–20 ft', between(17, 20)], ['22', '22–24 ft', between(21, 24)], ['26', '26–28 ft', between(25, 28)], ['30', '30 ft and up', p => p.L >= 29]] },
  { key: 'cond', label: 'Condition', cats: ['c'], kind: 'checks', opts: ['New / one-trip', 'Used', 'Refurbished', 'As-is'].map(c => [c, c, p => p.cond === c]) },
  { key: 'axr', label: 'Axle rating', cats: ['t'], kind: 'chips', opts: [['3500', '3,500 lb', p => p.ax === 3500], ['5200', '5,200 lb', p => p.ax === 5200], ['7000', '7,000 lb and up', p => p.ax >= 7000]] },
  { key: 'axn', label: 'Number of axles', cats: ['t'], kind: 'chips', opts: [['1', 'Single', p => p.axn === 1], ['2', 'Tandem', p => p.axn === 2], ['3', 'Triple', p => p.axn === 3]] },
  { key: 'nose', label: 'Front', cats: ['t'], kind: 'chips', opts: ['V-nose', 'Flat nose', 'Gooseneck'].map(n => [n, n, p => p.nose === n]) },
  { key: 'col', label: 'Color', cats: ['t'], kind: 'swatch', opts: Object.keys(COLORS).map(c => [c, c, p => p.col === c]) },
  { key: 'cf', label: 'Features', cats: ['c'], kind: 'checks', mode: 'and', opts: Object.entries(CFEAT).map(([k, l]) => [k, l, k === 'hc' ? (p => !!p.hc) : (p => p.f.includes(k))]) },
  { key: 'tf', label: 'Features', cats: ['t'], kind: 'checks', mode: 'and', opts: Object.entries(TFEAT).map(([k, l]) => [k, l, p => p.f.includes(k)]) },
  { key: 'price', label: 'Price', cats: ['all', 'c', 't'], kind: 'chips', dyn: true },
];
const facetOpts = fc => fc.dyn ? PRICE[F.cat] : fc.opts;
const SORTS = { rec: 'Recommended', plh: 'Price: low to high', phl: 'Price: high to low', szl: 'Size: largest first', szs: 'Size: smallest first' };

/* ---------- persistent state ---------- */
const store = {
  get(k, d) { try { const v = localStorage.getItem('bt:' + k); return v ? JSON.parse(v) : d; } catch { return d; } },
  set(k, v) { try { localStorage.setItem('bt:' + k, JSON.stringify(v)); } catch { /* storage unavailable */ } },
};
let cart = []; // copy of the Shopify cart, filled by takeCart()
let compare = store.get('compare', []).filter(id => BY.has(id));
let zipSaved = store.get('zip', '');
let cartNote = ''; // the Shopify cart note
let lastOrder = null;

const newFilters = (cat = 'all') => ({ cat, q: '', sel: {} });
let F = newFilters();
let sortKey = 'rec';
let shown = 24;
let shopScroll = 0;

/* ---------- helpers ---------- */
const $ = (s, el = document) => el.querySelector(s);
const $$ = (s, el = document) => [...el.querySelectorAll(s)];
const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const icon = (n, cls = 'icon') => `<svg class="${cls}" aria-hidden="true"><use href="#i-${n}"/></svg>`;
const money = v => {
  const cents = Math.round(v * 100) % 100 !== 0;
  return v.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: cents ? 2 : 0, maximumFractionDigits: cents ? 2 : 0 });
};
const lb = v => v.toLocaleString('en-US') + ' lb';
function sizeLabel(p) {
  if (p.c === 't') return p.W && p.L ? `${p.W} × ${p.L} ft` : '';
  if (p.metric || !p.L) return '';
  return p.W ? `${p.L} × ${p.W} ft` : `${p.L} ft`;
}
function axleLabel(p, short) {
  const n = { 1: 'Single', 2: 'Tandem', 3: 'Triple' }[p.axn];
  const r = p.ax ? lb(p.ax) : '';
  if (n && r) return short ? `${n} ${r}` : `${n} ${r} ${p.axn > 1 ? 'axles' : 'axle'}`;
  if (n) return `${n} axle`;
  return r ? `${r} axles` : '';
}
function cardSpec(p) { // the size is already in the short name
  if (p.c === 'c' && p.cs) return p.cs;
  const b = p.c === 'c'
    ? [p.cond, p.yr, p.brand, ...p.f.filter(k => ['insulated', 'power', 'hvac', 'windows', 'cargoworthy', 'watertight'].includes(k)).map(k => CFEAT[k])]
    : [axleLabel(p, true), p.col, p.f.includes('blackout') ? 'Blackout' : (TFEAT[p.f[0]] || '')];
  const out = b.filter(Boolean).slice(0, 3).map(String);
  if (out.length) return out.join(' · ');
  return p.g === 'storage' || p.g === 'cold' ? '' : groupLabel(p); // the short name already says what it is
}
function pdpTags(p) {
  const b = p.c === 'c'
    ? [sizeLabel(p), p.hc ? 'High cube' : '', p.cond || '']
    : [sizeLabel(p), axleLabel(p, true), p.nose || ''];
  const out = b.filter(Boolean);
  return out.length ? out : [groupLabel(p)];
}
function thumb(p, extra = '') {
  if (!p.n) return `<div class="ph ph-empty ${extra}" role="img" aria-label="No photo yet">${icon(p.c === 't' ? 'trailer' : 'box')}</div>`;
  const fit = p.ar < 1.15 || p.ar > 1.6 ? ' fit' : '';
  return `<div class="ph${fit} ${extra}" data-src="${imgSrc(p, 0, 480)}" role="img" aria-label="${esc(p.st)}"></div>`;
}
function frame(p, k, w = 1400) {
  return `background-image:url('${imgSrc(p, k, w)}');background-size:contain;background-position:center`;
}
const cartCount = () => cart.reduce((s, l) => s + l.qty, 0);
const cartTotal = () => cart.reduce((s, l) => s + BY.get(l.id).p * l.qty, 0);
function saveCompare() { store.set('compare', compare); syncCounts(); renderTray(); }
function syncCounts() {
  const n = cartCount();
  $$('[data-cart-count]').forEach(el => { el.textContent = n || ''; el.dataset.n = n; });
  $$('[data-open-cart]').forEach(el => el.setAttribute('aria-label', `Open cart, ${n} ${n === 1 ? 'item' : 'items'}`));
  $$('[data-cmp-count]').forEach(el => { el.textContent = compare.length || ''; el.dataset.n = compare.length; });
}

/* lazy sprite-sheet backgrounds */
const io = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
  for (const e of entries) if (e.isIntersecting) { loadPh(e.target); io.unobserve(e.target); }
}, { rootMargin: '400px 0px' }) : null;
function loadPh(el) { el.style.backgroundImage = `url("${el.dataset.src}")`; }
function hydrate(root = document) {
  $$('.ph[data-src]', root).forEach(el => { if (el.style.backgroundImage) return; io ? io.observe(el) : loadPh(el); });
}

/* ---------- search ---------- */
const SYN = [
  [/\bconex\b/g, 'container'], [/\breefers?\b/g, 'refrigerated'], [/\bfridge\b/g, 'refrigerated'], [/\bfreezers?\b/g, 'refrigerated'],
  [/\bhi(?:gh)?[ -]?cubes?\b|\bhc\b/g, 'high cube'], [/\bcargo trailers?\b/g, 'enclosed trailer'], [/\b(restrooms?|bathrooms?|wc)\b/g, 'toilet'],
  [/\b(feet|foot|ft\.)\b/g, 'ft'], [/(\d)\s*['′’]/g, '$1 ft'], [/(\d)(?:ft|foot|feet)\b/g, '$1 ft'], [/(\d(?:\.\d+)?)\s*[x×]\s*(\d)/g, '$1x$2'],
  [/\bmotorbikes?\b/g, 'motorcycle'], [/\bcars?\b/g, 'car'], [/\btrailers\b/g, 'trailer'], [/\bcontainers\b/g, 'container'],
];
const STOP = new Set(['ft', 'a', 'an', 'the', 'for', 'with', 'and', 'of', 'in', 'on', 'or', 'to', 'my', 'me', 'i', 'need', 'want', 'looking', 'buy', 'sale', 'price', 'cheap', 'best']);
function norm(s) {
  s = String(s).toLowerCase();
  for (const [re, r] of SYN) s = s.replace(re, r);
  return s.replace(/[^a-z0-9.x ]+/g, ' ').replace(/\s+/g, ' ').trim();
}
CAT.forEach(p => {
  const extra = [
    groupLabel(p), p.c === 'c' ? 'container shipping storage conex' : 'enclosed trailer cargo',
    p.u.map(u => USES[u]).join(' '), p.L ? p.L + ' ft' : '', p.W ? p.W + ' ft wide' : '', p.W && p.L && p.c === 't' ? `${p.W}x${p.L} ${Math.floor(p.W)}x${p.L}` : '', // "8x16" also finds 8.5 x 16
    p.hc ? 'high cube' : '', p.cond || '', p.col || '', p.nose || '', p.brand || '',
    p.f.map(k => (p.c === 'c' ? CFEAT : TFEAT)[k] || '').join(' '), p.sku,
  ].join(' ');
  p._t = norm(p.t + ' ' + p.st).split(' ');
  p._w = norm(p.t + ' ' + p.st + ' ' + extra).split(' ');
});
/* Typo tolerance: every word in the catalog is the dictionary. A query word that starts no catalog word
   is matched to the closest one (1 wrong letter for short words, 2 for 7+ letters, swapped letters count as 1). */
const ALIAS = { // other names and common misspellings that edit distance alone would not reach
  reefer: 'refrigerated', refer: 'refrigerated', fridge: 'refrigerated', freezer: 'refrigerated', cooler: 'refrigerated', chiller: 'refrigerated', frozen: 'refrigerated',
  conex: 'container', connex: 'container', conux: 'container', cont: 'container', can: 'container',
  restroom: 'toilet', bathroom: 'toilet', potty: 'toilet', porta: 'toilet', lavatory: 'toilet', shower: 'toilet',
  motorbike: 'motorcycle', bike: 'motorcycle', dirtbike: 'motorcycle', moto: 'motorcycle',
  shed: 'storage', warehouse: 'storage', cabin: 'office', hut: 'office', site: 'office',
  vending: 'concession kiosk', food: 'concession kiosk cafe', bbq: 'concession kiosk', coffee: 'cafe kiosk', shop: 'kiosk shop', stall: 'kiosk',
};
const DF = new Map(); // how many units use each word
CAT.forEach(p => new Set(p._w).forEach(w => { if (/^[a-z]{3,}$/.test(w)) DF.set(w, (DF.get(w) || 0) + 1); }));
const VOCAB = [...DF.keys()];
const DICT = [...new Set([...VOCAB, ...Object.keys(ALIAS)])].filter(w => !(w.endsWith('s') && DF.has(w.slice(0, -1)))); // suggest "toilet", not "toilets"
const known = t => VOCAB.some(w => w.startsWith(t));
function osa(a, b, max) { // Damerau (optimal string alignment) distance, gives up above max
  if (Math.abs(a.length - b.length) > max) return max + 1;
  let p2 = null, p1 = Array.from({ length: b.length + 1 }, (_, j) => j);
  for (let i = 1; i <= a.length; i++) {
    const c = [i]; let lo = i;
    for (let j = 1; j <= b.length; j++) {
      let v = Math.min(p1[j] + 1, c[j - 1] + 1, p1[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, p2[j - 2] + 1);
      c[j] = v; if (v < lo) lo = v;
    }
    if (lo > max) return max + 1;
    p2 = p1; p1 = c;
  }
  return p1[b.length];
}
function closest(t) {
  if (t.length < 4) return null;
  const max = t.length >= 7 ? 2 : 1;
  let best = null, bd = max + 0.5;
  for (const w of DICT) {
    let d = osa(t, w, max);
    if (t.length >= 5 && w.length > t.length) d = Math.min(d, osa(t, w.slice(0, t.length), max) + 0.25); // still typing
    if (d > bd) continue;
    const df = DF.get(ALIAS[w] ? ALIAS[w].split(' ')[0] : w) || 0;
    if (d < bd || df > best.df) { best = { w, df }; bd = d; }
  }
  return best && best.w;
}
function splitWord(t) { // "carhauler" -> "car hauler"
  for (let i = 3; i <= t.length - 3; i++) {
    const a = t.slice(0, i), b = t.slice(i);
    if ((DF.has(a) || ALIAS[a]) && (DF.has(b) || ALIAS[b])) return [a, b];
  }
  return null;
}
function resolveTok(t, fixed) {
  if (/^\d/.test(t)) return { show: t, alts: [t] };
  const alts = new Set();
  if (ALIAS[t]) ALIAS[t].split(' ').forEach(a => alts.add(a));
  if (known(t)) alts.add(t);
  else if (t.length > 4 && t.endsWith('s') && known(t.slice(0, -1))) alts.add(t.slice(0, -1));
  if (alts.size) return { show: t, alts: [...alts], fix: fixed };
  const w = closest(t);
  if (!w) return { show: t, alts: [] };
  return { show: w, alts: [...(ALIAS[w] ? ALIAS[w].split(' ') : []), w], fix: true };
}
function qTokens(q) { return norm(q).split(' ').filter(t => t && !STOP.has(t)); }
function tokHit(words, t) {
  if (/^\d/.test(t)) return words.includes(t);
  if (DF.has(t)) return words.some(w => w === t || w === t + 's' || w === t + 'es');
  return words.some(w => w.startsWith(t));
}
const QCACHE = new Map();
function searchCat(q) {
  if (QCACHE.has(q)) return QCACHE.get(q);
  const toks = [];
  for (const t of qTokens(q)) {
    const parts = !/^\d/.test(t) && !known(t) && !ALIAS[t] ? splitWord(t) : null;
    const wl = /^\d[\d.]*x(\d+)$/.exec(t); // a width x length we do not stock: fall back to the length
    if (wl && !CAT.some(p => p._w.includes(t))) toks.push({ show: wl[1] + ' ft', alts: [wl[1]], fix: true });
    else if (parts) parts.forEach(x => toks.push(resolveTok(x, true))); else toks.push(resolveTok(t, false));
  }
  const hitBy = toks.map(() => 0);
  const lv = CAT.map(p => toks.map((r, i) => {
    const size = r.alts.some(a => a === String(p.L) || a === String(p.W)); // a bare number ranks the unit of that size first
    const l = size || r.alts.some(a => !/^\d/.test(a) && tokHit(p._t, a)) ? 3 : r.alts.some(a => tokHit(p._w, a)) ? 1 : 0;
    if (l) hitBy[i]++;
    return l;
  }));
  const wt = toks.map((r, i) => (r.fix ? 0.8 : 1) * (1 + Math.log(CAT.length / Math.max(1, hitBy[i]))));
  const scores = new Map(); let most = 0;
  CAT.forEach((p, k) => {
    let m = 0, s = 0;
    lv[k].forEach((l, i) => { if (l) { m++; s += l * wt[i]; } });
    if (m) { scores.set(p.id, m * 1000 + s); most = Math.max(most, m); }
  });
  // When no unit matches every word, keep the units that match the most words.
  for (const [id, v] of scores) if (Math.floor(v / 1000) < most) scores.delete(id);
  let fixedQ = null;
  if (toks.some(r => r.fix)) fixedQ = toks.map(r => r.show).join(' ');
  const res = { toks, scores, partial: most > 0 && most < toks.length, missing: toks.filter((r, i) => !hitBy[i]).map(r => r.show), fixedQ };
  if (QCACHE.size > 200) QCACHE.clear();
  QCACHE.set(q, res);
  return res;
}
function searchNote(q, S) { // one line above the results when we changed or loosened the query
  if (!S || !S.scores.size) return '';
  if (S.partial && S.missing.length) return `Nothing matches “${esc(S.missing.join(' '))}”. Showing the closest matches${S.fixedQ ? ` for “${esc(S.fixedQ)}”` : ''}.`;
  if (S.partial) return `No unit matches every word. Showing the closest matches${S.fixedQ ? ` for “${esc(S.fixedQ)}”` : ''}.`;
  if (S.fixedQ) return `Showing results for <b>“${esc(S.fixedQ)}”</b>`;
  return '';
}

/* ---------- filtering ---------- */
function activeFacets() { return FACETS.filter(fc => fc.cats.includes(F.cat)); }
function passes(p, skip) {
  if (F.cat !== 'all' && p.c !== F.cat) return false;
  if (F.q && !p._qs) return false;
  for (const fc of activeFacets()) {
    if (fc.key === skip) continue;
    const s = F.sel[fc.key];
    if (!s || !s.size) continue;
    const tests = facetOpts(fc).filter(o => s.has(o[0])).map(o => o[2]);
    if (!tests.length) continue;
    if (fc.mode === 'and' ? !tests.every(t => t(p)) : !tests.some(t => t(p))) return false;
  }
  return true;
}
function prepQuery() {
  const S = F.q ? searchCat(F.q) : null;
  CAT.forEach(p => { p._qs = S && S.toks.length ? S.scores.get(p.id) || 0 : 1; });
}
function results() {
  prepQuery();
  const list = CAT.filter(p => passes(p));
  const cmp = {
    rec: F.q ? (a, b) => b._qs - a._qs || a.r - b.r : (a, b) => a.r - b.r,
    plh: (a, b) => a.p - b.p, phl: (a, b) => b.p - a.p,
    szl: (a, b) => (b.L || 0) - (a.L || 0) || a.p - b.p, szs: (a, b) => (a.L || 999) - (b.L || 999) || a.p - b.p,
  }[sortKey];
  return list.sort(cmp);
}
function toggleSel(key, val) {
  const s = F.sel[key] || (F.sel[key] = new Set());
  s.has(val) ? s.delete(val) : s.add(val);
}
function applyPreset(pr) {
  F = newFilters(pr.cat || 'all');
  if (pr.q) F.q = pr.q;
  for (const [k, vals] of Object.entries(pr.sel || {})) F.sel[k] = new Set(vals);
  sortKey = 'rec'; shown = 24; shopScroll = 0;
}
const preset = obj => esc(JSON.stringify(obj));

/* ---------- card ---------- */
function quoteWa(p) { // opens WhatsApp with a ready-made quote request for this unit
  const msg = `Hi ${CONFIG.brand}, I'd like a quote for several units of this product:
${p.st}${p.sku ? ` (SKU ${p.sku})` : ''}
Listed price: ${money(p.p)} each, delivery included

Quantity: 
Delivery ZIP code: 
Needed by: `;
  return `https://wa.me/${CONFIG.whatsapp}?text=${encodeURIComponent(msg)}`;
}
const offPct = p => p.cp ? Math.round((1 - p.p / p.cp) * 100) : 0;
const offBadge = p => offPct(p) > 0 ? `<span class="off-badge">-${offPct(p)}%</span>` : '';
function priceHtml(p) {
  return `<p class="price-wrap"><span class="price">${money(p.p)}</span>${p.cp ? `<s class="cmp-price"><span class="sr">Regular price </span>${money(p.cp)}</s>` : ''}</p>`;
}
function card(p) {
  return `<article class="card"><a class="card-link" href="#p-${p.id}">
      <div class="card-media">${thumb(p)}${offBadge(p)}</div>
      <div><h3 class="card-title">${esc(p.st)}</h3><p class="card-spec">${esc(cardSpec(p))}</p>${priceHtml(p)}</div>
    </a></article>`;
}

/* ---------- views ---------- */
const view = $('#view');
function setView(html, nav) {
  view.innerHTML = html;
  hydrate(view);
  const navs = nav === 'containers' || nav === 'trailers' ? [nav, 'shop'] : [nav];
  $$('[data-nav]').forEach(a => { if (navs.includes(a.dataset.nav)) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current'); });
}
function countFor(pr) {
  const keep = [F, sortKey, shown, shopScroll];
  applyPreset(pr);
  const n = results().length;
  [F, sortKey, shown, shopScroll] = keep;
  prepQuery();
  return n;
}

const COLLECTIONS = [
  ['Storage containers', { cat: 'c', sel: { group: ['storage'] } }, p => p.g === 'storage'],
  ['Refrigerated containers', { cat: 'c', sel: { group: ['cold'] } }, p => p.g === 'cold'],
  ['Offices & site cabins', { cat: 'c', sel: { group: ['office'] } }, p => p.g === 'office'],
  ['Bars, cafés & kiosks', { cat: 'c', sel: { group: ['business'] } }, p => p.g === 'business'],
  ['Toilets & welfare', { cat: 'c', sel: { group: ['welfare'] } }, p => p.g === 'welfare'],
  ['Container pools', { cat: 'c', sel: { group: ['pool'] } }, p => p.g === 'pool'],
  ['Cargo trailers', { cat: 't', sel: { use: ['cargo'] } }, p => p.c === 't' && p.u.includes('cargo')],
  ['Car haulers', { cat: 't', sel: { use: ['car'] } }, p => p.c === 't' && p.u.includes('car')],
  ['Motorcycle & ATV trailers', { cat: 't', sel: { use: ['moto'] } }, p => p.c === 't' && p.u.includes('moto')],
  ['Event trailers', { cat: 't', sel: { use: ['event'] } }, p => p.c === 't' && p.u.includes('event')],
];
const HOME_ROWS = [
  ['Storage containers', 'Steel boxes for tools, stock and equipment.', { cat: 'c', sel: { group: ['storage'] } }, p => p.g === 'storage'],
  ['Enclosed cargo trailers', 'Lockable trailers for tools, gear and equipment.', { cat: 't', sel: { use: ['cargo'] } }, p => p.c === 't' && p.g === 'cargo'],
  ['Car haulers', '8.5 ft wide trailers for cars, bikes and ATVs.', { cat: 't', sel: { use: ['car'] } }, p => p.c === 't' && p.g === 'car'],
  ['Refrigerated containers', 'Reefers and freezers for cold storage.', { cat: 'c', sel: { group: ['cold'] } }, p => p.g === 'cold'],
  ['Offices & site cabins', 'Ready-made offices, canteens and workshops.', { cat: 'c', sel: { group: ['office'] } }, p => p.g === 'office'],
  ['Bars, cafés & kiosks', 'Converted containers for a business.', { cat: 'c', sel: { group: ['business'] } }, p => p.g === 'business'],
];
function viewHome() {
  const min = list => Math.min(...list.map(p => p.p));
  const usedPics = new Set();
  const collTiles = COLLECTIONS.map(([label, pr, test]) => {
    const list = CAT.filter(test), pic = list.find(p => p.n && !usedPics.has(p.id)) || list[0];
    if (pic) usedPics.add(pic.id);
    return `<a class="coll" href="#shop" data-preset="${preset(pr)}">${pic ? thumb(pic) : ''}<b>${esc(label)}</b><span>${list.length} units · from ${money(min(list))}</span></a>`;
  }).join('');
  const productSections = HOME_ROWS.map(([title, sub, pr, test]) => {
    const all = CAT.filter(test), list = all.filter(p => p.n).slice(0, 8);
    return `<section class="section home-sec"><div class="wrap">
      <div class="sec-head"><div><h2>${esc(title)}</h2><p>${esc(sub)}</p></div><a class="link" href="#shop" data-preset="${preset(pr)}">See all ${all.length}</a></div>
      <div class="home-grid">${list.map(card).join('')}</div>
    </div></section>`;
  }).join('');
  const needTiles = Object.entries(NEEDS).map(([k, n]) => {
    const list = CAT.filter(n.test);
    const pic = list.find(p => p.n) || list[0];
    return `<a class="need" href="#shop" data-preset="${preset({ sel: { job: [k] } })}">
      ${pic ? thumb(pic) : ''}
      <span class="need-body"><span class="need-title">${esc(n.label)}</span><span class="need-meta">${list.length} units · from ${money(min(list))}</span></span></a>`;
  }).join('');
  setView(`
  <section class="hero">
    <picture class="hero-pic"><source media="(max-width: 899px)" srcset="${BT.heroM}" width="896" height="1120"><img class="hero-bg" src="${BT.hero}" width="1344" height="752" alt="A blue shipping container and a black enclosed trailer on a gravel lot, with a delivery truck carrying a red container"></picture>
    <div class="wrap">
      <h1>Containers and enclosed trailers, delivery included.</h1>
      <p class="hero-sub">Pick a size, see the full price and pay online. Every price includes delivery to a US address.</p>
      <div class="hero-cta"><a class="btn btn-primary" href="#containers">Shop containers</a><a class="btn btn-light" href="#trailers">Shop trailers</a></div>
    </div>
  </section>

  <section class="finder-band"><div class="wrap">
    <form class="finder" id="finder" aria-labelledby="fdTitle">
      <h2 id="fdTitle">Find your unit</h2>
      <div class="seg" role="group" aria-label="What are you looking for">
        <button type="button" data-fd="c" aria-pressed="true">Container</button>
        <button type="button" data-fd="t" aria-pressed="false">Trailer</button>
      </div>
      <div class="finder-fields" id="fdFields"></div>
      <button class="btn btn-primary" type="submit" id="fdGo">Show units</button>
    </form>
  </div></section>

  <section class="section"><div class="wrap">
    <div class="sec-head"><div><h2>Shop by collection</h2><p>${CAT.length} containers, cabins and trailers.</p></div></div>
    <div class="coll-grid">${collTiles}</div>
  </div></section>
${productSections}

  <section class="section how"><div class="wrap">
    <div class="sec-head"><div><h2>How ordering works</h2><p>Three steps from browsing to delivery.</p></div></div>
    <ol class="how-steps">
      <li><span class="how-n" aria-hidden="true">1</span><span class="trust-ic">${icon('search')}</span><h3>Pick your unit</h3><p>Filter by size, condition or axle rating and look through the photos and specs.</p></li>
      <li><span class="how-n" aria-hidden="true">2</span><span class="trust-ic">${icon('card')}</span><h3>Pay by card</h3><p>The price already includes delivery to your US address. Sales tax is added at checkout where it applies.</p></li>
      <li><span class="how-n" aria-hidden="true">3</span><span class="trust-ic">${icon('truck-fast')}</span><h3>Agree a delivery day</h3><p>After your order we contact you to set a delivery day, then the unit arrives at your site.</p></li>
    </ol>
  </div></section>

  <section class="section"><div class="wrap">
    <div class="sec-head"><div><h2>Questions buyers ask</h2></div><a class="link" href="#guide">Buying guide</a></div>
    ${faq()}
  </div></section>`, 'home');
  initFinder();
}

function sizeStack() {
  const rows = [
    { len: 10, fill: '#9C8456', ink: '#FFFFFF', label: '10 ft', sub: 'About 70 sq ft of floor', pr: { cat: 'c', sel: { clen: ['10'] } } },
    { len: 20, fill: '#4F6D7A', ink: '#FFFFFF', label: '20 ft', sub: 'About 150 sq ft of floor', pr: { cat: 'c', sel: { clen: ['20'] } } },
    { len: 40, fill: '#34516A', ink: '#FFFFFF', label: '40 ft', sub: 'About 300 sq ft of floor', pr: { cat: 'c', sel: { clen: ['40'] } } },
  ];
  const unit = 12, h = 8.5 * unit, x0 = 10;
  let y = 20, svg = '';
  rows.forEach(r => {
    const w = r.len * unit;
    let ribs = '';
    for (let x = x0 + 9; x < x0 + w - 18; x += 9) ribs += `<path d="M${x} ${y + 6}v${h - 12}" stroke="${r.ink}" stroke-opacity=".18" stroke-width="2"/>`;
    const dx = x0 + w - 14;
    const outside = w < 200, tx = outside ? x0 + w + 14 : x0 + 14, tfill = outside ? 'var(--ink)' : r.ink;
    svg += `<a href="#shop" data-preset="${preset(r.pr)}" aria-label="${r.label} containers">
      <rect class="box" x="${x0}" y="${y}" width="${w}" height="${h}" rx="3" fill="${r.fill}"/>${ribs}
      <path d="M${dx} ${y + 6}v${h - 12}M${dx + 7} ${y + 6}v${h - 12}" stroke="${r.ink}" stroke-opacity=".55" stroke-width="2"/>
      <text class="lbl" x="${tx}" y="${y + 38}" style="fill:${tfill}">${r.label}</text>
      <text class="sub" x="${tx}" y="${y + 60}" style="fill:${tfill};opacity:.85">${r.sub}</text></a>`;
    y += h + 14;
  });
  const total = y, ground = total - 14, px = x0 + 40 * unit + 26, ph = 6 * unit;
  const people = `<g aria-hidden="true"><circle cx="${px}" cy="${ground - ph + 6}" r="6" fill="var(--ink-2)"/><rect x="${px - 6}" y="${ground - ph + 13}" width="12" height="${ph - 13}" rx="5" fill="var(--ink-2)"/>
    <text class="sub" x="${px}" y="${ground - ph - 8}" text-anchor="middle">6 ft</text></g>`;
  const counts = [['10', '10 ft'], ['20', '20 ft'], ['40', '40 ft'], ['45', '45 ft'], ['53', '53 ft']].map(([k, l]) => {
    const pr = { cat: 'c', sel: { clen: [k] } };
    return `<a href="#shop" data-preset="${preset(pr)}">${l} containers <span>${countFor(pr)} available ${icon('right')}</span></a>`;
  }).join('');
  return `<div class="sizes">
    <svg class="diagram" viewBox="0 0 ${x0 + 40 * unit + 46} ${total}" role="img" aria-label="10, 20 and 40 ft containers drawn to scale, stacked, next to a 6 ft person">${svg}${people}</svg>
    <div><p class="muted" style="margin-bottom:12px">Standard containers are 8 ft wide and 8 ft 6 in tall. High cube units add a foot of height (9 ft 6 in), useful for shelving or conversions.</p><div class="size-list">${counts}</div></div>
  </div>`;
}

function faq() {
  const qa = [
    ['Is delivery included in the price?', 'Yes. Every price includes delivery to a US address, so there is no separate delivery charge at checkout. Sales tax is added where it applies.'],
    ['When and how do I pay?', 'You pay once by credit or debit card on our secure checkout. We never ask for wire transfers, Zelle, Cash App, gift cards or crypto. After the order we contact you to agree a delivery day.'],
    ['What if the unit arrives damaged or not as described?', 'Check it before you sign the delivery receipt. Write any problem on the receipt, take photos and send them to us. We repair, replace or refund it.'],
    ['What is the difference between new / one-trip and used?', 'A one-trip container has crossed the ocean once and looks close to new. Used units show dents and surface rust from service; cargo-worthy ones can still be shipped, wind and watertight ones are best for storage on site. The Container condition page shows photos of each grade.'],
    ['Can I return a unit?', 'Yes. You can return a unit within 40 days of delivery if it is in the same condition as when it arrived. The Return policy page (linked at the bottom of every page) explains the steps.'],
    ['Can I order several units or a whole fleet?', 'Yes. Use "Request a quote" on any product page and tell us how many you need and where they are going.'],
    ['Which trailer size fits a car?', 'Most cars need an 8.5 ft wide trailer that is 18 ft or longer. Measure your vehicle and leave room to walk around it and strap it down.'],
  ];
  return `<div class="faq">${qa.map(([q, a]) => `<details><summary>${esc(q)}${icon('down')}</summary><p>${esc(a)}</p></details>`).join('')}</div>`;
}

/* hero finder */
let fd = 'c';
function initFinder() {
  const form = $('#finder');
  if (!form) return;
  const fields = $('#fdFields');
  const draw = () => {
    $$('[data-fd]', form).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.fd === fd)));
    fields.innerHTML = fd === 'c'
      ? `<div class="fld"><label for="fdA">Length</label><select class="input" id="fdA"><option value="">Any length</option><option value="10">10 ft</option><option value="20" selected>20 ft</option><option value="40">40 ft</option><option value="45">45 ft</option><option value="53">53 ft</option></select></div>
         <div class="fld"><label for="fdB">Condition</label><select class="input" id="fdB"><option value="">Any condition</option><option>New / one-trip</option><option>Used</option><option>Refurbished</option></select></div>`
      : `<div class="fld"><label for="fdA">Width</label><select class="input" id="fdA"><option value="">Any width</option><option value="6">6 ft</option><option value="7">7 ft</option><option value="8.5" selected>8.5 ft</option></select></div>
         <div class="fld"><label for="fdB">Length</label><select class="input" id="fdB"><option value="">Any length</option><option value="12">12 ft or less</option><option value="14">14–16 ft</option><option value="18">18–20 ft</option><option value="22">22–24 ft</option><option value="26">26–28 ft</option><option value="30">30 ft and up</option></select></div>`;
    update();
  };
  const pr = () => {
    const a = $('#fdA').value, b = $('#fdB').value, sel = {};
    if (fd === 'c') { if (a) sel.clen = [a]; if (b) sel.cond = [b]; } else { if (a) sel.tw = [a]; if (b) sel.tlen = [b]; }
    return { cat: fd, sel };
  };
  const update = () => {
    const n = countFor(pr());
    $('#fdGo').textContent = n ? `Show ${n} ${n === 1 ? 'unit' : 'units'}` : 'No exact match – show all';
  };
  form.addEventListener('click', e => { const b = e.target.closest('[data-fd]'); if (b) { fd = b.dataset.fd; draw(); } });
  form.addEventListener('change', update);
  form.addEventListener('submit', e => {
    e.preventDefault();
    const p = pr(); applyPreset(p);
    if (!results().length) applyPreset({ cat: fd });
    go('shop');
  });
  draw();
}

function viewShop() {
  const list = results();
  const jobs = F.sel.job;
  const coll = collNow(); const title = coll ? esc(coll.t) : F.q ? `Results for “${esc(F.q)}”` : jobs && jobs.size === 1 ? esc(NEEDS[[...jobs][0]].label) : catLabel(F.cat);
  const tabs = ['all', 'c', 't'].map(c => {
    const keep = F.cat; F.cat = c; const n = CAT.filter(p => passesBase(p)).length; F.cat = keep;
    return `<button type="button" role="tab" data-cat="${c}" aria-selected="${F.cat === c}">${c === 'all' ? 'All' : c === 'c' ? 'Containers' : 'Trailers'}<small class="num">${n}</small></button>`;
  }).join('');
  setView(`<div class="wrap">
    <div class="shop-top">
      <nav class="crumbs" aria-label="Breadcrumb"><a href="#home">Home</a>${icon('right', 'icon')}<span>Shop</span></nav>
      <div class="shop-title"><h1>${title}</h1><span class="muted num" id="resCount" aria-live="polite"></span></div>
      ${coll && coll.d ? `<div class="coll-intro">${coll.d}</div>` : ''}<p class="q-note" id="qNote" hidden></p>
      <div class="cat-tabs" role="tablist" aria-label="Category">${tabs}</div>
    </div>
    <div class="shop">
      <aside class="filters" id="filters" aria-label="Filters">
        <div class="f-head"><h2>Filters</h2><button class="icon-btn" type="button" data-close-filters aria-label="Close filters">${icon('x')}</button></div>
        <div class="f-body" id="facets">${facetsHtml()}</div>
        <div class="f-foot"><button class="btn btn-ghost" type="button" data-clear>Clear all</button><button class="btn btn-primary" type="button" data-close-filters id="fShow">Show results</button></div>
      </aside>
      <section aria-label="Results">
        <div class="toolbar">
          <button class="btn btn-secondary f-btn" type="button" id="fOpen">${icon('sliders')}Filters <span id="fCount"></span></button>
          <div class="active grow" id="activeChips"></div>
          <label class="sort"><span>Sort by</span><select class="select" id="sort">${Object.entries(SORTS).map(([k, l]) => `<option value="${k}" ${k === sortKey ? 'selected' : ''}>${l}</option>`).join('')}</select></label>
        </div>
        <div id="results"></div>
      </section>
    </div></div>`, 'shop');
  refreshShop(list);
}
function passesBase(p) { // category tab counts ignore facet selections but keep the job and the query
  if (F.cat !== 'all' && p.c !== F.cat) return false;
  const jobs = F.sel.job;
  if (jobs && jobs.size && ![...jobs].some(k => NEEDS[k].test(p))) return false;
  if (F.q && !p._qs) return false;
  return true;
}
const MORE_FACETS = new Set(['cf', 'axr', 'axn', 'nose', 'col', 'tf']); // folded under "More filters"
function facetsHtml() {
  // inside Containers / Trailers, "Type" and "Built for" cover the job; keep the job facet only while one is chosen
  const list = activeFacets().filter(fc => fc.key !== 'job' || F.cat === 'all' || (F.sel.job && F.sel.job.size));
  const main = list.filter(fc => !MORE_FACETS.has(fc.key)), more = list.filter(fc => MORE_FACETS.has(fc.key));
  const open = more.some(fc => F.sel[fc.key] && F.sel[fc.key].size);
  return main.map(facetHtml).join('') +
    (more.length ? `<details class="more-filters" ${open ? 'open' : ''}><summary>More filters ${icon('down')}</summary>${more.map(facetHtml).join('')}</details>` : '');
}
function facetHtml(fc) {
  {
    const opts = facetOpts(fc);
    const s = F.sel[fc.key] || new Set();
    let body;
    if (fc.kind === 'checks') {
      body = opts.map(([v, l]) => `<label class="opt" data-opt="${fc.key}|${esc(v)}"><input type="checkbox" data-facet="${fc.key}" value="${esc(v)}" ${s.has(v) ? 'checked' : ''}><span>${esc(l)}</span><span class="n"></span></label>`).join('');
    } else if (fc.kind === 'swatch') {
      body = opts.map(([v, l]) => `<label class="opt" data-opt="${fc.key}|${esc(v)}"><input type="checkbox" data-facet="${fc.key}" value="${esc(v)}" ${s.has(v) ? 'checked' : ''}><span class="sw" style="background:${COLORS[v]}"></span><span>${esc(l)}</span><span class="n"></span></label>`).join('');
    } else {
      body = `<div class="chips">${opts.map(([v, l]) => `<button type="button" class="chip" data-chip="${fc.key}" value="${esc(v)}" aria-pressed="${s.has(v)}" data-opt="${fc.key}|${esc(v)}">${esc(l)} <small class="n"></small></button>`).join('')}</div>`;
    }
    return `<div class="facet" data-facet-box="${fc.key}"><h3>${esc(fc.label)}</h3>${body}</div>`;
  }
}
function updateFacetCounts() {
  for (const fc of activeFacets()) {
    const opts = facetOpts(fc);
    const base = CAT.filter(p => passes(p, fc.mode === 'and' ? null : fc.key));
    let visible = 0;
    for (const [v, , test] of opts) {
      const n = base.filter(test).length;
      const el = view.querySelector(`[data-opt="${fc.key}|${CSS.escape(v)}"]`);
      if (!el) continue;
      const on = (F.sel[fc.key] || new Set()).has(v);
      el.querySelector('.n').textContent = n;
      const off = n === 0 && !on;
      el.classList.toggle('is-off', off);
      if (el.tagName === 'BUTTON') el.disabled = off;
      else { el.hidden = off; el.querySelector('input').disabled = off; }
      if (!off) visible++;
    }
    const box = view.querySelector(`[data-facet-box="${fc.key}"]`);
    if (box) box.hidden = visible === 0;
  }
}
function activeCount() { return Object.entries(F.sel).filter(([k]) => activeFacets().some(f => f.key === k)).reduce((s, [, v]) => s + v.size, 0) + (F.q ? 1 : 0); }
function refreshShop(list = results()) {
  updateFacetCounts();
  $('#resCount').textContent = `${list.length} ${list.length === 1 ? 'unit' : 'units'}`;
  $('#fShow').textContent = list.length ? `Show ${list.length} ${list.length === 1 ? 'unit' : 'units'}` : 'No matches';
  const n = activeCount();
  $('#fCount').textContent = n ? `(${n})` : '';
  // active chips
  const chips = [];
  if (F.q) chips.push(`<button type="button" data-unq>“${esc(F.q)}”${icon('x')}</button>`);
  for (const fc of activeFacets()) {
    const s = F.sel[fc.key]; if (!s) continue;
    for (const [v, l] of facetOpts(fc)) if (s.has(v)) chips.push(`<button type="button" data-unsel="${fc.key}" value="${esc(v)}">${esc(l)}${icon('x')}</button>`);
  }
  if (chips.length > 1) chips.push(`<button type="button" class="clear-all" data-clear>Clear all</button>`);
  $('#activeChips').innerHTML = chips.join('');
  const note = F.q ? searchNote(F.q, searchCat(F.q)) : '';
  $('#qNote').innerHTML = note; $('#qNote').hidden = !note;
  // results
  const res = $('#results');
  if (!list.length) {
    res.innerHTML = F.q && !searchCat(F.q).scores.size ? `<div class="empty"><h2>Nothing found for “${esc(F.q)}”.</h2><p>Try a size or a type, such as “20 ft”, “reefer”, “office” or “car hauler”, or ask us on WhatsApp and we will find one for you.</p>
      <div class="chips"><button class="btn btn-primary" type="button" data-clear>See all units</button><a class="btn btn-secondary" href="https://wa.me/${CONFIG.whatsapp}?text=${encodeURIComponent(`Hi, I'm looking for: ${F.q}`)}" target="_blank" rel="noopener">Ask on WhatsApp</a></div></div>` : `<div class="empty"><h2>No units match all of these filters.</h2><p>Remove a filter, or start again from everything in this category.</p>
      <div class="chips"><button class="btn btn-primary" type="button" data-clear>Clear all filters</button><a class="btn btn-secondary" href="#guide">Ask us to find one</a></div></div>`;
    return;
  }
  const slice = list.slice(0, shown);
  res.innerHTML = `<div class="grid">${slice.map(card).join('')}</div>` +
    (list.length > shown ? `<div class="more"><span>Showing ${shown} of ${list.length}</span><button class="btn btn-secondary" type="button" data-more>Show ${Math.min(24, list.length - shown)} more</button></div>` : '');
  hydrate(res);
}

function viewProduct(id) {
  const p = BY.get(id);
  if (!p) { setView(`<div class="wrap"><div class="empty" style="margin-block:40px"><h2>We couldn't find that unit.</h2><p>It may have been sold. Browse similar units instead.</p><div class="chips"><a class="btn btn-primary" href="#shop">Browse all units</a></div></div></div>`, 'shop'); return; }
  const n = Math.max(p.n, 1);
  const slides = p.n ? Array.from({ length: n }, (_, k) => `<div class="g-slide"><img src="${imgSrc(p, k, 1200)}" srcset="${imgSrc(p, k, 600)} 600w, ${imgSrc(p, k, 1200)} 1200w, ${imgSrc(p, k, 1800)} 1800w" sizes="(max-width: 899px) 100vw, 58vw" width="1200" height="900" alt="${esc(p.seo || p.st)}, photo ${k + 1} of ${n}" ${k ? 'loading="lazy"' : 'fetchpriority="high"'}></div>`).join('')
    : `<div class="g-slide ph-empty">${icon(p.c === 't' ? 'trailer' : 'box')}</div>`;
  const thumbs = p.n > 1 ? `<div class="g-thumbs">${Array.from({ length: n }, (_, k) => `<button type="button" data-g="${k}" aria-label="Show photo ${k + 1}" ${k === 0 ? 'aria-current="true"' : ''} style="${frame(p, k, 240)}"></button>`).join('')}</div>
     <div class="g-dots" aria-hidden="true">${Array.from({ length: n }, (_, k) => `<span ${k === 0 ? 'aria-current="true"' : ''}></span>`).join('')}</div>` : '';
  const crumbsCat = p.c === 'c' ? ['containers', 'Containers'] : ['trailers', 'Enclosed trailers'];
  const near = (a, b) => Math.abs(a.p - p.p) - Math.abs(b.p - p.p);
  const sameType = CAT.filter(q => q.id !== p.id && q.c === p.c && q.g === p.g).sort(near);
  const related = sameType.concat(CAT.filter(q => q.id !== p.id && q.c === p.c && q.g !== p.g).sort(near)).slice(0, 8); // always a full row: same type first, then the closest prices
  setView(`<div class="wrap pdp">
    <nav class="crumbs" aria-label="Breadcrumb"><a href="#shop">${icon('arrow-left')}Back to results</a><span class="crumb-extra" aria-hidden="true">/</span><a class="crumb-extra" href="#${crumbsCat[0]}">${crumbsCat[1]}</a><span class="crumb-extra" aria-hidden="true">/</span><a class="crumb-extra" href="#shop" data-preset="${preset(p.c === 'c' ? { cat: 'c', sel: { group: [p.g] } } : { cat: 't', sel: { use: [p.g] } })}">${esc(groupLabel(p))}</a></nav>
    <div class="pdp-grid">
      <section class="gallery" aria-label="Photos">
        <div class="g-main">${offBadge(p)}<div class="g-track" id="gTrack" tabindex="0" aria-label="Photo gallery, swipe or use arrow keys">${slides}</div>
          ${p.n > 1 ? `<button class="g-nav g-prev" type="button" data-gstep="-1" aria-label="Previous photo">${icon('left')}</button><button class="g-nav g-next" type="button" data-gstep="1" aria-label="Next photo">${icon('right')}</button><span class="g-count" id="gCount">1 / ${n}</span>` : ''}${p.n ? `<button class="g-zoom" type="button" data-lb-open aria-label="View photos full screen">${icon('expand')}</button>` : ''}</div>
        ${thumbs}
      </section>
      <section class="buy">
        <p class="eyebrow">${esc(groupLabel(p))}${p.sku ? ` · SKU <span class="num">${esc(p.sku)}</span>` : ''}</p>
        <h1>${esc(p.st)}</h1>
        ${p.t !== p.st ? `<p class="sub-title">${esc(p.t)}</p>` : ''}
        <div class="buy-spec">${pdpTags(p).map(b => `<span class="tag">${esc(b)}</span>`).join('')}</div>
        ${gradeOf(p) ? `<p class="cond-note cond-${gradeOf(p).tone}"><b>${esc(gradeOf(p).name)}</b> · ${esc(gradeOf(p).sum.split('. ')[0].replace(/:$/, ''))}. <a href="#condition">What this grade means</a></p>` : ''}
        <div class="price-row"><span class="price-lg">${money(p.p)}</span>${p.cp ? `<s class="cmp-lg"><span class="sr">Regular price </span>${money(p.cp)}</s><span class="save">Save ${money(p.cp - p.p)}</span>` : ''}</div>
        <p class="muted price-note">Per unit, delivery included</p>
        <div class="buy-actions">
          <div class="qty"><button type="button" data-qstep="-1" aria-label="Decrease quantity">${icon('minus')}</button><input id="pQty" type="number" inputmode="numeric" min="1" max="20" value="1" aria-label="Quantity"><button type="button" data-qstep="1" aria-label="Increase quantity">${icon('plus')}</button></div>
          <button class="btn btn-primary" type="button" data-add="${p.id}" data-qty-from="pQty">${icon('cart')}Add to cart</button>
          <button class="btn btn-dark buy-now" type="button" data-buy="${p.id}" data-qty-from="pQty">Buy now</button>
        </div>
        <div class="buy-links">
          <a class="link" href="${quoteWa(p)}" target="_blank" rel="noopener"><svg class="wa-ic" aria-hidden="true"><use href="#i-wa"/></svg>Request a quote for several units</a>
          <button class="link" type="button" data-cmp-toggle="${p.id}">${compare.includes(p.id) ? 'Remove from compare' : 'Add to compare'}</button>
        </div>
        <ul class="trust" aria-label="Why buy from us">
          <li><span class="trust-ic">${icon('truck-fast')}</span><b>Free Shipping</b><span class="trust-txt">Delivery to any US address is included.</span></li>
          <li><span class="trust-ic">${icon('return')}</span><b>40-Day Returns</b><span class="trust-txt">Simple, hassle-free return policy. <a href="#returns">Read the policy</a></span></li>
          <li><span class="trust-ic">${icon('shield')}</span><b>Secure Checkout</b><span class="trust-txt">Card payment only. We never ask for wire or Zelle.</span></li>
        </ul>
        <ul class="assure">
          <li>${icon('truck')}<span>After your order we contact you to agree a delivery day.</span></li>
          <li>${icon('search')}<span>Check the unit when it arrives. Note any problem before you sign and we put it right.</span></li>
          <li>${icon('phone')}<span>Questions about this unit? Call <b>${esc(CONFIG.phone)}</b></span></li>
        </ul>
      </section>
    </div>
    <div class="pdp-lower">
      <section class="plate" aria-labelledby="plateTitle"><h2 id="plateTitle">Specifications</h2><dl>${plateRows(p)}</dl></section>
      <section class="desc"><h2>About this unit</h2><div class="desc-body" id="desc"><p class="muted">Loading the description…</p></div></section>
    </div>
    ${confidence(p)}
    ${related.length ? `<section class="related"><div class="sec-head"><h2>Similar units</h2><a class="link" href="#shop" data-preset="${preset(p.c === 'c' ? { cat: 'c', sel: { group: [p.g] } } : { cat: 't', sel: { use: [p.g] } })}">See all ${icon('right')}</a></div><div class="row-scroll">${related.map(card).join('')}</div></section>` : ''}
  </div>
  <div class="buybar"><div><div class="price">${money(p.p)}${p.cp ? ` <s class="cmp-price">${money(p.cp)}</s>` : ''}</div><div class="muted" style="font-size:13px">delivery included</div></div><div class="buybar-btns"><button class="btn btn-primary" type="button" data-add="${p.id}" data-qty-from="pQty">Add to cart</button><button class="btn btn-dark" type="button" data-buy="${p.id}" data-qty-from="pQty">Buy now</button></div></div>`, 'shop');
  initGallery(n);
  loadDetails(p).then(d => { const el = $('#desc'); if (el) el.innerHTML = descHtml(d[p.id], p); }).catch(() => { const el = $('#desc'); if (el) el.innerHTML = '<p class="muted">The description could not be loaded. Refresh the page to try again.</p>'; });
}
function plateRows(p) {
  const rows = [];
  if (p.c === 'c') {
    rows.push(['Type', groupLabel(p)]);
    if (sizeLabel(p)) rows.push(['Size', sizeLabel(p)]);
    if (p.hc) rows.push(['Height', 'High cube, 9 ft 6 in']);
    if (p.cond) rows.push(['Condition', p.cond]);
    if (p.brand) rows.push(['Refrigeration', p.brand]);
    if (p.yr) rows.push(['Year', p.yr]);
    const doors = p.f.filter(k => ['rollup', 'side', 'double', 'mandoor'].includes(k)).map(k => CFEAT[k]);
    if (doors.length) rows.push(['Doors', doors.join(', ')]);
    const fit = p.f.filter(k => ['insulated', 'power', 'windows', 'hvac', 'opentop', 'cargoworthy', 'watertight'].includes(k)).map(k => CFEAT[k]);
    if (fit.length) rows.push(['Features', fit.join(', ')]);
  } else {
    rows.push(['Type', groupLabel(p)]);
    if (sizeLabel(p)) rows.push(['Size', sizeLabel(p)]);
    if (p.H) rows.push(['Interior height', `${p.H} ft`]);
    if (axleLabel(p)) rows.push(['Axles', axleLabel(p)]);
    if (p.gv) rows.push(['GVWR', lb(p.gv)]);
    if (p.nose) rows.push(['Front', p.nose]);
    if (p.col) rows.push(['Color', p.col]);
    if (p.f.length) rows.push(['Features', p.f.map(k => TFEAT[k]).join(', ')]);
  }
  if (p.sku) rows.push(['SKU', p.sku]);
  return rows.map(([k, v]) => `<dt>${esc(k)}</dt><dd>${esc(v)}${k === 'Condition' ? ` <a class="dd-link" href="#condition">What this means</a>` : ''}</dd>`).join('');
}
let detailsP = null;
function loadDetails(p) {
  return fetch(`${BASE}/products/${encodeURIComponent(p.h)}?view=data${PASS}`, { credentials: 'same-origin' })
    .then(r => { if (!r.ok || blockedByPassword(r)) throw new Error(r.status); return r.json(); })
    .then(x => ({ [p.id]: x.d && Object.keys(x.d).length ? x.d : (parseDesc(x.html) || (x.html ? [{ t: 'raw', x: x.html }] : null)) }));
}
function parseDesc(html) { // the import's description layout (lead, Details, Condition, Good for, What's included) back into the card's fields
  if (!html || !/<h3/i.test(html)) return null;
  const doc = new DOMParser().parseFromString(html, 'text/html'), d = { s: '', sp: [], c: '', g: [], inc: [] };
  let sec = 'lead';
  for (const el of doc.body.children) {
    const txt = el.textContent.trim();
    if (el.tagName === 'H3') { sec = { details: 'sp', condition: 'c', 'good for': 'g', "what's included": 'inc', delivery: 'skip' }[txt.toLowerCase()] || 'other'; continue; }
    if (sec === 'other') return null;
    if (sec === 'lead') d.s += (d.s ? ' ' : '') + txt;
    else if (sec === 'c') d.c += (d.c ? ' ' : '') + txt;
    else if (sec !== 'skip') d[sec].push(...[...el.querySelectorAll('li')].map(li => li.textContent.trim()));
  }
  return d.s ? d : null;
}
function descHtml(d, p) {
  if (d && !Array.isArray(d)) return descCard(d, p);
  const blocks = d;
  if (!blocks || !blocks.length) return '<p class="muted">No further description for this unit. Call us for details.</p>';
  const li = x => { const m = /^([^:]{2,48}):\s+(.+)$/.exec(x); return m ? `<li><strong>${esc(m[1])}:</strong> ${esc(m[2])}</li>` : `<li>${esc(x)}</li>`; };
  return blocks.map(b => b.t === 'raw' ? b.x : b.t === 'h' ? `<h3>${esc(b.x)}</h3>` : b.t === 'ul' ? `<ul>${b.x.map(li).join('')}</ul>` : `<p>${esc(b.x)}</p>`).join('');
}
function descCard(d, p) {
  const row = x => { const m = /^([^:]{2,40}):\s+(.+)$/.exec(x); return m ? `<li><span>${esc(m[1])}</span><b>${esc(m[2])}</b></li>` : `<li><b>${esc(x)}</b></li>`; };
  const delivery = p.c === 'c'
    ? 'Delivery to your US address is included. Containers arrive on a tilt-bed truck, which needs firm, level ground and a clear, straight approach. Tell us about gates, trees or overhead wires when you order.'
    : "Delivery to your US address is included. Before towing, check that your vehicle and hitch are rated for the trailer's loaded weight.";
  return `<p class="desc-lead">${esc(d.s)}</p>
    ${d.sp && d.sp.length ? `<h3>Details</h3><ul class="desc-specs">${d.sp.map(row).join('')}</ul>` : ''}
    ${d.c ? `<h3>Condition</h3><p>${esc(d.c)}</p>` : ''}
    ${d.g && d.g.length ? `<h3>Good for</h3><div class="buy-spec">${d.g.map(x => `<span class="tag">${esc(x)}</span>`).join('')}</div>` : ''}
    ${d.inc && d.inc.length ? `<h3>What's included</h3><ul>${d.inc.map(x => `<li>${esc(x)}</li>`).join('')}</ul>` : ''}
    <h3>Delivery</h3><p>${delivery}</p>`;
}
function initGallery(n) {
  const track = $('#gTrack'); if (!track || n < 2) return;
  const setIdx = i => {
    const c = $('#gCount'); if (c) c.textContent = `${i + 1} / ${n}`;
    $$('.g-thumbs button').forEach((b, k) => b.setAttribute('aria-current', String(k === i)));
    $$('.g-dots span').forEach((s, k) => s.setAttribute('aria-current', String(k === i)));
  };
  let t;
  track.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => setIdx(Math.round(track.scrollLeft / track.clientWidth)), 60); }, { passive: true });
  track.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); stepGallery(e.key === 'ArrowRight' ? 1 : -1); } });
}
/* full-screen photo viewer */
let lbP = null, lbI = 0;
function openLightbox(p, k) {
  if (!p || !p.n) return;
  lbP = p; lbI = k || 0;
  $('#lbThumbs').innerHTML = p.n > 1 ? Array.from({ length: p.n }, (_, i) => `<button type="button" data-lb-go="${i}" aria-label="Photo ${i + 1}" style="${frame(p, i, 240)}"></button>`).join('') : '';
  $$('.lb-nav').forEach(b => { b.hidden = p.n < 2; });
  $('#lb').hidden = false; document.body.style.overflow = 'hidden';
  lbShow(lbI);
  setTimeout(() => $('#lb .lb-x').focus(), 30);
}
function lbShow(i) {
  const p = lbP, n = p.n;
  lbI = (i + n) % n;
  const img = $('#lbImg');
  img.classList.remove('zoomed'); img.style.transformOrigin = '';
  img.setAttribute('style', frame(p, lbI));
  img.setAttribute('aria-label', `${p.st}, photo ${lbI + 1} of ${n}`);
  $('#lbCount').textContent = `${lbI + 1} / ${n}`;
  $$('#lbThumbs button').forEach((b, k) => b.setAttribute('aria-current', String(k === lbI)));
}
function closeLightbox() {
  $('#lb').hidden = true; document.body.style.overflow = '';
  if (lbP && $('#gTrack')) stepGallery(0, lbI);
  lbP = null;
}
(function initLightbox() {
  const img = $('#lbImg'), stage = $('#lbStage');
  const origin = (x, y) => { const r = img.getBoundingClientRect(); img.style.transformOrigin = `${((x - r.left) / r.width) * 100}% ${((y - r.top) / r.height) * 100}%`; };
  img.addEventListener('click', e => {
    if (img.classList.contains('zoomed')) { img.classList.remove('zoomed'); return; }
    img.classList.remove('zoomed'); origin(e.clientX, e.clientY); img.classList.add('zoomed');
  });
  stage.addEventListener('mousemove', e => { if (img.classList.contains('zoomed')) origin(e.clientX, e.clientY); });
  let sx = null, sy = null;
  stage.addEventListener('touchstart', e => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
  stage.addEventListener('touchmove', e => {
    if (img.classList.contains('zoomed')) { e.preventDefault(); origin(e.touches[0].clientX, e.touches[0].clientY); }
  }, { passive: false });
  stage.addEventListener('touchend', e => {
    if (sx == null || img.classList.contains('zoomed')) { sx = null; return; }
    const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) lbShow(lbI + (dx < 0 ? 1 : -1));
    sx = null;
  });
  document.addEventListener('keydown', e => {
    if ($('#lb').hidden) return;
    if (e.key === 'Escape') { e.stopImmediatePropagation(); closeLightbox(); }
    else if (e.key === 'ArrowRight') lbShow(lbI + 1);
    else if (e.key === 'ArrowLeft') lbShow(lbI - 1);
  }, true);
})();
function stepGallery(d, abs) {
  const track = $('#gTrack'); if (!track) return;
  const n = track.children.length, i = Math.round(track.scrollLeft / track.clientWidth);
  const j = abs != null ? abs : (i + d + n) % n;
  track.scrollTo({ left: j * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
}

function viewCompare() {
  const items = compare.map(id => BY.get(id)).filter(Boolean);
  if (!items.length) {
    setView(`<div class="wrap" style="padding-block:28px 56px"><div class="shop-title"><h1>Compare</h1></div>
      <div class="empty" style="margin-top:18px"><h2>Nothing to compare yet.</h2><p>Tick “Compare” on up to four products, then come back here to see them side by side.</p><div class="chips"><a class="btn btn-primary" href="#shop">Browse units</a></div></div></div>`, 'compare');
    return;
  }
  const rowsDef = [
    ['Price', p => money(p.p)], ['Type', p => groupLabel(p)], ['Size', p => sizeLabel(p) || '—'],
    ['Height', p => p.c === 'c' ? (p.hc ? 'High cube, 9 ft 6 in' : '—') : (p.H ? `${p.H} ft interior` : '—')],
    ['Condition', p => p.c === 'c' ? (p.cond || '—') : '—'], ['Axles', p => p.c === 't' ? (axleLabel(p) || '—') : '—'],
    ['GVWR', p => p.gv ? lb(p.gv) : '—'], ['Front', p => p.nose || '—'], ['Color', p => p.col || '—'],
    ['Features', p => p.f.map(k => (p.c === 'c' ? CFEAT : TFEAT)[k]).join(', ') || '—'],
  ];
  const rows = rowsDef.filter(([, fn]) => items.some(p => fn(p) !== '—')).map(([l, fn]) => {
    const vals = items.map(fn); const diff = new Set(vals).size > 1;
    return `<tr><th scope="row">${l}</th>${vals.map(v => `<td class="${diff && l !== 'Price' ? 'cmp-diff' : ''}">${esc(v)}</td>`).join('')}</tr>`;
  }).join('');
  setView(`<div class="wrap" style="padding-block:22px 56px">
    <nav class="crumbs" aria-label="Breadcrumb"><a href="#shop">${icon('arrow-left')}Back to results</a></nav>
    <div class="shop-title" style="margin-bottom:16px"><h1>Compare</h1><span class="muted">${items.length} of 4 · differences are highlighted</span></div>
    <div class="cmp-wrap"><table class="cmp-table"><thead><tr><th scope="col"><span class="sr">Product</span></th>${items.map(p => `<td class="cmp-head"><a href="#p-${p.id}">${thumb(p)}<span>${esc(p.st)}</span></a>
      <div class="actions"><button class="btn btn-primary" type="button" data-add="${p.id}">Add to cart</button><button class="btn btn-ghost" type="button" data-uncmp="${p.id}">Remove</button></div></td>`).join('')}</tr></thead>
      <tbody>${rows}</tbody></table></div></div>`, 'compare');
}

const STATES = 'AL Alabama|AK Alaska|AZ Arizona|AR Arkansas|CA California|CO Colorado|CT Connecticut|DE Delaware|DC District of Columbia|FL Florida|GA Georgia|HI Hawaii|ID Idaho|IL Illinois|IN Indiana|IA Iowa|KS Kansas|KY Kentucky|LA Louisiana|ME Maine|MD Maryland|MA Massachusetts|MI Michigan|MN Minnesota|MS Mississippi|MO Missouri|MT Montana|NE Nebraska|NV Nevada|NH New Hampshire|NJ New Jersey|NM New Mexico|NY New York|NC North Carolina|ND North Dakota|OH Ohio|OK Oklahoma|OR Oregon|PA Pennsylvania|RI Rhode Island|SC South Carolina|SD South Dakota|TN Tennessee|TX Texas|UT Utah|VT Vermont|VA Virginia|WA Washington|WV West Virginia|WI Wisconsin|WY Wyoming'.split('|').map(s => [s.slice(0, 2), s.slice(3)]);

function viewCheckout() {
  const lines = express ? [express] : cart;
  const total = lines.reduce((s, l) => s + BY.get(l.id).p * l.qty, 0), count = lines.reduce((s, l) => s + l.qty, 0);
  if (!lines.length) {
    setView(`<div class="wrap" style="padding-block:28px 56px"><div class="empty"><h2>Your cart is empty.</h2><p>Add a container or trailer to your cart, or press "Buy now" on a product page.</p><div class="chips"><a class="btn btn-primary" href="#shop">Browse units</a></div></div></div>`, '');
    return;
  }
  const fld = (id, label, attrs = '', cls = '', err = 'Fill in this field.') => `<div class="fld ${cls}"><label for="${id}">${label}</label><input class="input" id="${id}" name="${id}" ${attrs}><span class="err-msg" id="${id}-err">${err}</span></div>`;
  setView(`<div class="wrap">
    <div class="co-head">
      <nav class="crumbs" aria-label="Breadcrumb">${express ? `<a class="link" href="#p-${express.id}">${icon('arrow-left')}Back to product</a>` : `<button class="link" type="button" data-open-cart>${icon('arrow-left')}Back to cart</button>`}</nav>
      <h1>Checkout</h1>
      ${express && cart.length ? `<p class="co-express">You are buying this unit on its own. The ${cartCount()} ${cartCount() === 1 ? 'item' : 'items'} in your cart stay there.</p>` : ''}
      <p class="muted">Delivery to your US address is already in every price.</p>
    </div>
    <form class="co" id="coForm" novalidate>
    <div>
      <section class="co-sec"><h2><span class="step-n">1</span>Contact</h2><div class="form-grid">
        ${fld('email', 'Email', 'type="email" autocomplete="email" required', 'h', 'Enter an email address like name@company.com.')}
        ${fld('phone', 'Phone', 'type="tel" autocomplete="tel" required', 'h', 'Enter a phone number with area code.')}
        <div class="fld"><label for="company">Company <span class="opt-note">(optional)</span></label><input class="input" id="company" autocomplete="organization"></div>
      </div></section>
      <section class="co-sec"><h2><span class="step-n">2</span>Delivery address</h2>
        <div class="form-grid">
          ${fld('name', 'Full name', 'autocomplete="name" required')}
          ${fld('addr1', 'Street address', 'autocomplete="address-line1" required')}
          <div class="fld"><label for="addr2">Apt, suite or lot <span class="opt-note">(optional)</span></label><input class="input" id="addr2" autocomplete="address-line2"></div>
          ${fld('city', 'City', 'autocomplete="address-level2" required', 't')}
          <div class="fld t statef"><label for="state">State</label><select class="input" id="state" autocomplete="address-level1" required><option value="">Choose</option>${STATES.map(([c, n]) => `<option value="${c}">${n}</option>`).join('')}</select><span class="err-msg">Choose a state.</span></div>
          ${fld('zip', 'ZIP code', `inputmode="numeric" autocomplete="postal-code" maxlength="10" required value="${esc(zipSaved)}"`, 't zipf', 'Enter a 5-digit ZIP code.')}
        </div>
        <div class="form-grid" style="margin-top:14px"><div class="fld"><label for="cartNote">Delivery notes <span class="opt-note">(optional)</span></label><textarea class="input" id="cartNote" rows="2" placeholder="Gate code, ground surface, where the doors should face">${esc(cartNote)}</textarea></div></div>
        <p class="co-hint">${icon('truck')}<span>Delivery is included. After your order we contact you to agree a delivery day.</span></p>
      </section>
      <section class="co-sec"><h2><span class="step-n">3</span>Payment</h2>
        <div class="pay-box"><b>Credit or debit card</b><span>In the live store, card details are entered here on the secure payment step. This prototype does not ask for card details.</span></div>
        <div style="margin-top:14px">${payBox()}</div>
      </section>
      <button class="btn btn-primary btn-block" type="submit" style="margin-top:18px;min-height:54px;font-size:17px">Pay ${money(total)}</button>
      <p class="muted" style="margin-top:10px;font-size:14px;text-align:center">Sales tax, where it applies to your state, is added before you pay.</p>
    </div>
    <aside class="co-sum collapsed" id="coSum" aria-label="Order summary">
      <button class="co-sum-toggle" type="button" id="coSumToggle" aria-expanded="false"><span>Order summary · ${count} ${count === 1 ? 'item' : 'items'}</span><span class="num">${money(total)} ${icon('down')}</span></button>
      <h2 class="desk">Order summary</h2>
      <div class="co-sum-body">
        <div>${lines.map(l => { const p = BY.get(l.id); return `<div class="line">${thumb(p)}<div><a class="line-title" href="#p-${p.id}">${esc(p.st)}</a><div class="line-spec">Qty ${l.qty} · ${money(p.p)} each</div></div><b class="num">${money(p.p * l.qty)}</b></div>`; }).join('')}</div>
        <div class="sum-row"><span>Subtotal</span><b class="num">${money(total)}</b></div>
        <div class="sum-row"><span>Delivery</span><span>Included</span></div>
        <div class="sum-row"><span>Sales tax</span><span class="muted">Calculated from your address</span></div>
        <div class="sum-row total"><span>Total before tax</span><span class="num">${money(total)}</span></div>
        <div class="co-note">${icon('truck')}<span>Delivery to your US address is already in these prices.</span></div>
        <details class="co-after"><summary>What happens after you pay ${icon('down')}</summary>${afterSteps()}</details>
      </div>
    </aside>
  </form></div>`, '');
  const form = $('#coForm');
  if (matchMedia('(min-width: 900px)').matches) $('#coSum').classList.remove('collapsed');
  $('#coSumToggle').addEventListener('click', () => { const s = $('#coSum'); const c = s.classList.toggle('collapsed'); $('#coSumToggle').setAttribute('aria-expanded', String(!c)); });
  form.addEventListener('input', e => { const f = e.target.closest('.fld'); if (f && f.classList.contains('err')) validateField(e.target); });
  form.addEventListener('submit', e => {
    e.preventDefault();
    const req = ['email', 'phone', 'name', 'addr1', 'city', 'state', 'zip'].map(id => $('#' + id));
    const bad = req.filter(el => !validateField(el));
    if (bad.length) { bad[0].focus(); return; }
    zipSaved = $('#zip').value.trim().slice(0, 5); store.set('zip', zipSaved);
    lastOrder = { no: 'BT-' + String(Math.floor(10000 + Math.random() * 90000)), lines: lines.map(l => ({ ...l })), total, email: $('#email').value.trim(), name: $('#name').value.trim().split(' ')[0], note: cartNote };
    if (express) express = null; else { cart = []; saveCart(); }
    cartNote = ''; store.set('note', '');
    go('order');
  });
}
function validateField(el) {
  const v = el.value.trim();
  let ok = !!v;
  if (ok && el.id === 'email') ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  if (ok && el.id === 'phone') ok = v.replace(/\D/g, '').length >= 10;
  if (ok && el.id === 'zip') ok = /^\d{5}(-\d{4})?$/.test(v);
  const f = el.closest('.fld');
  f.classList.toggle('err', !ok);
  el.setAttribute('aria-invalid', String(!ok));
  const msg = f.querySelector('.err-msg'); if (msg && msg.id) el.setAttribute('aria-describedby', msg.id);
  return ok;
}
function viewOrder() {
  if (!lastOrder) { go('home'); return; }
  const o = lastOrder;
  setView(`<div class="wrap"><div class="confirm">
    <div class="confirm-badge">${icon('check')}</div>
    <h1>Thanks, ${esc(o.name || 'your order is in')}. Your order is confirmed.</h1>
    <p class="muted" style="margin-top:10px;font-size:17px">Order <span class="order-no">${o.no}</span>. The confirmation goes to <b>${esc(o.email)}</b>.</p>
    <span class="proto-note">Prototype: no payment was taken and no email was sent.</span>
    <section class="co-sec" style="margin-top:22px"><h2>What happens next</h2>${afterSteps()}</section>
    <section class="co-sec"><h2>On delivery day</h2>${inspectList(BY.get(o.lines[0].id).c)}</section>
    <section class="co-sec"><h2>Your order</h2>${o.lines.map(l => { const p = BY.get(l.id); return `<div class="line" style="grid-template-columns:72px minmax(0,1fr) auto">${thumb(p)}<div><a class="line-title" href="#p-${p.id}">${esc(p.st)}</a><div class="line-spec">Qty ${l.qty}</div></div><b class="num">${money(p.p * l.qty)}</b></div>`; }).join('')}
      <div class="sum-row" style="margin-top:12px"><span>Delivery</span><span>Included</span></div>
      <div class="sum-row total" style="margin-top:6px"><span>Total before tax</span><span class="num">${money(o.total)}</span></div><p class="sum-note">Sales tax, where it applies, is shown on your receipt.</p>
      ${o.note ? `<p class="sum-note" style="margin-top:10px"><b>Delivery notes:</b> ${esc(o.note)}</p>` : ''}</section>
    <div class="chips" style="margin-top:18px"><a class="btn btn-primary" href="#shop">Keep browsing</a><a class="btn btn-secondary" href="#home">Back to home</a></div>
  </div></div>`, '');
}

/* Policy drafts. Highlighted [items] are business facts the owner must fill in; have a lawyer review before launch. */
const F_ = x => `<mark>[${x}]</mark>`;
const draftVal = v => /example\.com/.test(v) ? `<mark>${esc(v)}</mark>` : esc(v); // placeholder contact details show highlighted

/* Container condition grades. Photos are real listings from the catalog, chosen as typical examples of each grade. */
const GRADES = [
  { name: 'New / one-trip', tag: 'Like new', tone: 'ok', ph: [[6801, 0], [806, 2]], match: p => p.cond === 'New / one-trip', pre: { cat: 'c', sel: { cond: ['New / one-trip'] } },
    sum: 'Built new and shipped across the ocean once with cargo. The closest you can get to a brand-new container.',
    exp: ['Clean factory paint in one color', 'Straight walls and doors that open and seal easily', 'Clean wooden floor', 'No shipping-line logos'],
    best: 'Offices, workshops, conversions and storage where looks matter.' },
  { name: 'Refurbished', tag: 'Repaired & repainted', tone: 'ok', ph: [[796, 2], [4818, 1]], match: p => p.cond === 'Refurbished', pre: { cat: 'c', sel: { cond: ['Refurbished'] } },
    sum: 'A used container that has been repaired, cleaned and repainted. Many also get new doors, locks or shelving.',
    exp: ['Fresh paint inside and out', 'Damaged panels and seals repaired', 'Small dents may show under the new paint'],
    best: 'Storage and conversions at a lower price than new.' },
  { name: 'Used', tag: 'Cargo-worthy or wind & watertight', tone: 'mid', ph: [[6179, 0], [6363, 4]], match: p => p.cond === 'Used', pre: { cat: 'c', sel: { cond: ['Used'] } },
    sum: 'A container that has been in service at sea. Used units come in two grades, shown on the product page when known:',
    sub: [['Cargo-worthy', 'strong enough to be loaded and shipped by sea again.'], ['Wind & watertight', 'keeps rain and wind out; made for storage on land.']],
    exp: ['Original paint, often with shipping-line logos', 'Dents, scratches and surface rust from years at sea are normal'],
    best: 'Storage on farms, building sites and yards at the lowest price.' },
  { name: 'As-is', tag: 'No repairs', tone: 'warn', ph: [[6020, 0], [6075, 0]], match: p => p.cond === 'As-is', pre: { cat: 'c', sel: { cond: ['As-is'] } },
    sum: 'Sold exactly as it stands, without repairs. Read the photos and description carefully, and ask us before you buy.',
    exp: ['Visible wear, rust and old paint', 'Parts such as a refrigeration unit are not guaranteed to work'],
    best: 'Buyers who plan their own repairs or conversion.' },
];
const gradeOf = p => GRADES.find(g => g.match(p));
function gradeCards() {
  return `<div class="gc-grid">${GRADES.map(g => {
    const n = CAT.filter(g.match).length;
    const photos = g.ph.filter(([id]) => BY.get(id)).map(([id, k]) => `<a class="gc-ph" href="#p-${id}" style="${frame(BY.get(id), k, 700)}" aria-label="Example: ${esc(BY.get(id).st)}"></a>`).join('');
    return `<article class="gc gc-${g.tone}">
      <div class="gc-photos">${photos}</div>
      <div class="gc-body">
        <div class="gc-head"><h3>${esc(g.name)}</h3><span class="gc-tag">${esc(g.tag)}</span></div>
        <p>${esc(g.sum)}</p>
        ${g.sub ? `<ul class="gc-sub">${g.sub.map(([a, b]) => `<li><b>${esc(a)}:</b> ${esc(b)}</li>`).join('')}</ul>` : ''}
        <h4>What to expect</h4>
        <ul class="gc-exp">${g.exp.map(x => `<li>${icon('check')}<span>${esc(x)}</span></li>`).join('')}</ul>
        <p class="gc-best"><b>Best for:</b> ${esc(g.best)}</p>
        ${n ? `<a class="link" href="#shop" data-preset="${preset(g.pre)}">See ${n} ${esc(g.name.toLowerCase())} ${n === 1 ? 'container' : 'containers'} ${icon('right')}</a>` : ''}
      </div></article>`;
  }).join('')}</div>`;
}
function gradeStat() {
  const graded = CAT.filter(p => p.c === 'c' && p.cond).length;
  const good = CAT.filter(p => p.cond === 'New / one-trip' || p.cond === 'Refurbished').length;
  return graded && good / graded > 0.5 ? `<p class="gc-stat">${icon('check')}<span><b>${good} of our ${graded} graded containers are new / one-trip or refurbished.</b> Clean paint, sound doors and floors.</span></p>` : '';
}
function viewCondition() {
  setView(`<div class="wrap cond-page">
    <nav class="crumbs" aria-label="Breadcrumb"><a href="#home">Home</a>${icon('right')}<a href="#guide">Help</a>${icon('right')}<span>Container condition</span></nav>
    <h1>Container condition, explained</h1>
    <p class="lead">Every container on this site has a condition on its product page. Here is what each grade means and what it looks like, using photos from our own listings.</p>
    ${gradeStat()}
    ${gradeCards()}
    <section class="cond-more">
      <div><h2>Not sure which grade you need?</h2><p>Tell us what you will use it for and where it is going. We will point you to the right grade and size.</p>
        <a class="btn btn-secondary" href="https://wa.me/${CONFIG.whatsapp}?text=${encodeURIComponent('Hi, which container condition do I need? I will use it for: ')}" target="_blank" rel="noopener"><svg class="wa-ic" aria-hidden="true"><use href="#i-wa"/></svg>Ask on WhatsApp</a></div>
      <div><h2>You can check it on delivery</h2>${inspectList('c')}</div>
    </section>
  </div>`, 'guide');
}

/* Buying safely: payment, inspection on delivery, what happens after the order */
function payBox() {
  return `<div class="safe-box">
    <h3>${icon('shield')}How you pay</h3>
    <ul class="safe-list">
      <li>${icon('check')}<span>Pay by credit or debit card on our secure checkout. The price already includes delivery.</span></li>
      <li>${icon('check')}<span>Your card details go straight to the payment provider. We never see or store your full card number.</span></li>
      <li>${icon('check')}<span>Paying by card means you can dispute the charge with your bank if something goes wrong.</span></li>
      <li class="no">${icon('x')}<span><b>We never ask for wire transfers, Zelle, Cash App, gift cards or crypto.</b> If anyone asks you to pay that way in our name, do not pay and message us.</span></li>
    </ul>
    <div class="card-logos" role="list" aria-label="Cards accepted: Visa, Mastercard, American Express, Discover"><span class="cl" role="listitem" title="Visa"><svg viewBox="0 7.4 24 9" width="38" height="14" aria-hidden="true"><path fill="#1A1F71" d="M9.112 8.262L5.97 15.758H3.92L2.374 9.775c-.094-.368-.175-.503-.461-.658C1.447 8.864.677 8.627 0 8.479l.046-.217h3.3a.904.904 0 01.894.764l.817 4.338 2.018-5.102zm8.033 5.049c.008-1.979-2.736-2.088-2.717-2.972.006-.269.262-.555.822-.628a3.66 3.66 0 011.913.336l.34-1.59a5.207 5.207 0 00-1.814-.333c-1.917 0-3.266 1.02-3.278 2.479-.012 1.079.963 1.68 1.698 2.04.756.367 1.01.603 1.006.931-.005.504-.602.725-1.16.734-.975.015-1.54-.263-1.992-.473l-.351 1.642c.453.208 1.289.39 2.156.398 2.037 0 3.37-1.006 3.377-2.564m5.061 2.447H24l-1.565-7.496h-1.656a.883.883 0 00-.826.55l-2.909 6.946h2.036l.405-1.12h2.488zm-2.163-2.656l1.02-2.815.588 2.815zm-8.16-4.84l-1.603 7.496H8.34l1.605-7.496z"/></svg></span><span class="cl" role="listitem" title="Mastercard"><svg viewBox="0 0 38 24" width="34" height="21" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="#EB001B"/><circle cx="26" cy="12" r="11" fill="#F79E1B"/><path fill="#FF5F00" d="M19 3.6a11 11 0 0 1 0 16.8a11 11 0 0 1 0-16.8z"/></svg></span><span class="cl" role="listitem" title="American Express"><svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path fill="#2E77BC" d="M16.015 14.378c0-.32-.135-.496-.344-.622-.21-.12-.464-.135-.81-.135h-1.543v2.82h.675v-1.027h.72c.24 0 .39.024.478.125.12.13.104.38.104.55v.35h.66v-.555c-.002-.25-.017-.376-.108-.516-.06-.08-.18-.18-.33-.234l.02-.008c.18-.072.48-.297.48-.747zm-.87.407l-.028-.002c-.09.053-.195.058-.33.058h-.81v-.63h.824c.12 0 .24 0 .33.05.098.048.156.147.15.255 0 .12-.045.215-.134.27zM20.297 15.837H19v.6h1.304c.676 0 1.05-.278 1.05-.884 0-.28-.066-.448-.187-.582-.153-.133-.392-.193-.73-.207l-.376-.015c-.104 0-.18 0-.255-.03-.09-.03-.15-.105-.15-.21 0-.09.017-.166.09-.21.083-.046.177-.066.272-.06h1.23v-.602h-1.35c-.704 0-.958.437-.958.84 0 .9.776.855 1.407.87.104 0 .18.015.225.06.046.03.082.106.082.18 0 .077-.035.15-.08.18-.06.053-.15.07-.277.07zM0 0v10.096L.81 8.22h1.75l.225.464V8.22h2.043l.45 1.02.437-1.013h6.502c.295 0 .56.057.756.236v-.23h1.787v.23c.307-.17.686-.23 1.12-.23h2.606l.24.466v-.466h1.918l.254.465v-.466h1.858v3.948H20.87l-.36-.6v.585h-2.353l-.256-.63h-.583l-.27.614h-1.213c-.48 0-.84-.104-1.08-.24v.24h-2.89v-.884c0-.12-.03-.12-.105-.135h-.105v1.036H6.067v-.48l-.21.48H4.69l-.202-.48v.465H2.235l-.256-.624H1.4l-.256.624H0V24h23.786v-7.108c-.27.135-.613.18-.973.18H21.09v-.255c-.21.165-.57.255-.914.255H14.71v-.9c0-.12-.018-.12-.12-.12h-.075v1.022h-1.8v-1.066c-.298.136-.643.15-.928.136h-.214v.915h-2.18l-.54-.617-.57.6H4.742v-3.93h3.61l.518.602.554-.6h2.412c.28 0 .74.03.942.225v-.24h2.177c.202 0 .644.045.903.225v-.24h3.265v.24c.163-.164.508-.24.803-.24h1.89v.24c.194-.15.464-.24.84-.24h1.176V0H0zM21.156 14.955c.004.005.006.012.01.016.01.01.024.01.032.02l-.042-.035zM23.828 13.082h.065v.555h-.065zM23.865 15.03v-.005c-.03-.025-.046-.048-.075-.07-.15-.153-.39-.215-.764-.225l-.36-.012c-.12 0-.194-.007-.27-.03-.09-.03-.15-.105-.15-.21 0-.09.03-.16.09-.204.076-.045.15-.05.27-.05h1.223v-.588h-1.283c-.69 0-.96.437-.96.84 0 .9.78.855 1.41.87.104 0 .18.015.224.06.046.03.076.106.076.18 0 .07-.034.138-.09.18-.045.056-.136.07-.27.07h-1.288v.605h1.287c.42 0 .734-.118.9-.36h.03c.09-.134.135-.3.135-.523 0-.24-.045-.39-.135-.526zM18.597 14.208v-.583h-2.235V16.458h2.235v-.585h-1.57v-.57h1.533v-.584h-1.532v-.51M13.51 8.787h.685V11.6h-.684zM13.126 9.543l-.007.006c0-.314-.13-.5-.34-.624-.217-.125-.47-.135-.81-.135H10.43v2.82h.674v-1.034h.72c.24 0 .39.03.487.12.122.136.107.378.107.548v.354h.677v-.553c0-.25-.016-.375-.11-.516-.09-.107-.202-.19-.33-.237.172-.07.472-.3.472-.75zm-.855.396h-.015c-.09.054-.195.056-.33.056H11.1v-.623h.825c.12 0 .24.004.33.05.09.04.15.128.15.25s-.047.22-.134.266zM15.92 9.373h.632v-.6h-.644c-.464 0-.804.105-1.02.33-.286.3-.362.69-.362 1.11 0 .512.123.833.36 1.074.232.238.645.31.97.31h.78l.255-.627h1.39l.262.627h1.36v-2.11l1.272 2.11h.95l.002.002V8.786h-.684v1.963l-1.18-1.96h-1.02V11.4L18.11 8.744h-1.004l-.943 2.22h-.3c-.177 0-.362-.03-.468-.134-.125-.15-.186-.36-.186-.662 0-.285.08-.51.194-.63.133-.135.272-.165.516-.165zm1.668-.108l.464 1.118v.002h-.93l.466-1.12zM2.38 10.97l.254.628H4V9.393l.972 2.205h.584l.973-2.202.015 2.202h.69v-2.81H6.118l-.807 1.904-.876-1.905H3.343v2.663L2.205 8.787h-.997L.01 11.597h.72l.26-.626h1.39zm-.688-1.705l.46 1.118-.003.002h-.915l.457-1.12zM11.856 13.62H9.714l-.85.923-.825-.922H5.346v2.82H8l.855-.932.824.93h1.302v-.94h.838c.6 0 1.17-.164 1.17-.945l-.006-.003c0-.78-.598-.93-1.128-.93zM7.67 15.853l-.014-.002H6.02v-.557h1.47v-.574H6.02v-.51H7.7l.733.82-.764.824zm2.642.33l-1.03-1.147 1.03-1.108v2.253zm1.553-1.258h-.885v-.717h.885c.24 0 .42.098.42.344 0 .243-.15.372-.42.372zM9.967 9.373v-.586H7.73V11.6h2.237v-.58H8.4v-.564h1.527V9.88H8.4v-.507"/></svg></span><span class="cl" role="listitem" title="Discover"><svg viewBox="0 9.3 24 5.4" width="42" height="10" aria-hidden="true"><path fill="#231F20" d="M9.380 9.999c-1.124 0-2.025.884-2.025 1.99 0 1.118.878 1.984 2.007 1.984.319 0 .593-.063.93-.221v-.873c-.296.297-.559.416-.895.416-.747 0-1.277-.542-1.277-1.312 0-.73.547-1.306 1.243-1.306.354 0 .622.126.93.428v-.873a1.898 1.898 0 0 0-.913-.233zm-3.352 1.545c-.445-.165-.576-.273-.576-.479 0-.239.233-.422.553-.422.222 0 .405.091.598.308l.388-.508a1.665 1.665 0 0 0-1.117-.422c-.673 0-1.186.467-1.186 1.089 0 .524.239.792.936 1.043.291.103.438.171.513.217a.456.456 0 0 1 .222.394c0 .308-.245.536-.576.536-.354 0-.639-.177-.809-.507l-.479.461c.342.502.752.724 1.317.724.771 0 1.311-.513 1.311-1.249-.002-.603-.252-.876-1.095-1.185zM24 10.3a.29.29 0 0 1-.288.291.29.29 0 0 1-.291-.291v-.003A.29.29 0 1 1 24 10.3zm-.059.001a.235.235 0 0 0-.231-.239.234.234 0 0 0-.232.239c0 .132.104.239.232.239a.235.235 0 0 0 .231-.239zM3.472 13.887h.742v-3.803h-.742v3.803zm12.702-1.248l-1.014-2.554h-.81l1.614 3.9h.399l1.643-3.9h-.804l-1.028 2.554zm2.166 1.248h2.104v-.644h-1.362v-1.027h1.312v-.644h-1.312v-.844h1.362v-.644H18.34v3.803zm5.409-3.557l.11.138h-.097l-.094-.13v.13h-.08v-.334h.107c.081 0 .126.036.126.103.001.046-.025.08-.072.093zm-.006-.092c0-.029-.021-.043-.06-.043h-.014v.087h.014c.039 0 .06-.014.06-.044zm-1.228 2.047l1.197 1.602H22.8l-1.027-1.528h-.097v1.528h-.741v-3.803h1.1c.855 0 1.346.411 1.346 1.123 0 .583-.308.965-.866 1.078zm.103-1.038c0-.37-.251-.563-.713-.563h-.228v1.152h.217c.473-.001.724-.207.724-.589zm-19.487.742a1.91 1.91 0 0 1-.69 1.46c-.365.303-.781.439-1.357.439H.001v-3.803H1.09c1.202 0 2.041.781 2.041 1.904zm-.764-.006c0-.364-.154-.718-.411-.947-.245-.222-.536-.308-1.015-.308H.742v2.515h.199c.479 0 .782-.092 1.015-.302.256-.228.411-.593.411-.958z"/><path fill="#FF6000" d="M14.58 12a2.023 2.023 0 1 1-2.025-2.023h.002c1.118 0 2.023.906 2.023 2.023z"/></svg></span></div>
  </div>`;
}
function inspectList(c) {
  const look = c === 't'
    ? 'Check the lights with your tow vehicle, the tires, the ramp or doors and the floor.'
    : 'Open and close the doors, check the floor, and from inside with the doors shut, look for daylight through the roof or walls.';
  return `<ol class="insp">
    <li><b>Compare it with the listing.</b> Walk around the unit and match it with the photos and condition on its product page.</li>
    <li><b>Test it.</b> ${look}</li>
    <li><b>Note any problem before you sign.</b> If something is damaged or not as described, write it on the delivery receipt and take photos.</li>
    <li><b>Send us the photos</b> within 48 hours. We repair, replace or refund it. <a href="#returns">Return policy</a></li>
  </ol>`;
}
function afterSteps() {
  return `<ol class="after">
    <li><span class="after-n">1</span><div><b>Right away</b><p>You get an order confirmation email with your receipt.</p></div></li>
    <li><span class="after-n">2</span><div><b>Within 1 business day</b><p>We call or WhatsApp you to confirm the address, site access and a delivery day that suits you.</p></div></li>
    <li><span class="after-n">3</span><div><b>Before delivery</b><p>We confirm the delivery window with you. Delivery usually takes about 20 days from your order.</p></div></li>
    <li><span class="after-n">4</span><div><b>Delivery day</b><p>The unit is placed at your site. You check it before you sign the delivery receipt.</p></div></li>
    <li><span class="after-n">5</span><div><b>After delivery</b><p>You have 40 days to return it, and we are on WhatsApp if you have questions.</p></div></li>
  </ol>`;
}
function confidence(p) { // product page: three short answers buyers look for before paying
  return `<section class="confid" aria-labelledby="confTitle">
    <h2 id="confTitle">Buy with confidence</h2>
    <div class="confid-grid">
      <div class="confid-card">${payBox()}</div>
      <div class="confid-card"><h3>${icon('search')}Check it on delivery</h3>${inspectList(p.c)}</div>
      <div class="confid-card"><h3>${icon('truck')}What happens after you order</h3>${afterSteps()}</div>
    </div>
  </section>`;
}

/* About and contact */
function viewAbout() {
  const nc = CAT.filter(p => p.c === 'c').length, nt = CAT.filter(p => p.c === 't').length;
  setView(`<div class="wrap"><article class="policy about">
    <nav class="crumbs" aria-label="Breadcrumb"><a href="#home">Home</a>${icon('right')}<span>About us</span></nav>
    <h1>About ${esc(CONFIG.brand)}</h1>
    <p class="draft"><b>Draft.</b> Fill in the highlighted items before the store goes live.</p>
    <p class="lead">${esc(CONFIG.brand)} sells shipping containers, site cabins and enclosed trailers to homeowners, farms, contractors and small businesses across the United States. Every price includes delivery to your site.</p>
    <div class="about-facts">
      <div><b class="num">${nc}</b><span>containers and cabins</span></div>
      <div><b class="num">${nt}</b><span>enclosed trailers</span></div>
      <div><b>$0</b><span>extra for delivery</span></div>
      <div><b>40 days</b><span>to return a unit</span></div>
    </div>
    <h2>Who we are</h2>
    <p>${esc(CONFIG.brand)} is operated by ${esc(CONFIG.company)}, ${esc(ADDRESS)}. You can reach a real person on WhatsApp at <a href="https://wa.me/${CONFIG.whatsapp}" target="_blank" rel="noopener">${esc(CONFIG.phone)}</a> or by email at ${draftVal(CONFIG.email)}.</p>
    <h2>How we work</h2>
    <ul>
      <li>You choose your unit online, with photos, specifications and a clear condition grade on every container.</li>
      <li>You pay once by card on our secure checkout. Delivery is already in the price.</li>
      <li>We fulfil your order from our supplier's stock and arrange delivery to your site.</li>
      <li>We stay your contact from the order until the unit is in place and you are happy with it.</li>
    </ul>
    <h2>What we stand behind</h2>
    <div class="stand">
      <div>${icon('truck-fast')}<b>Delivery included</b><span>No delivery fee added at checkout.</span></div>
      <div>${icon('search')}<b>Check it on delivery</b><span>Note any problem before you sign and we put it right.</span></div>
      <div>${icon('return')}<b>40-day returns</b><span><a href="#returns">Read the return policy</a></span></div>
      <div>${icon('shield')}<b>Card payment only</b><span>We never ask for wire transfers, Zelle or gift cards.</span></div>
      <div>${icon('box')}<b>Honest condition grades</b><span><a href="#condition">See what each grade means</a></span></div>
      <div>${icon('wa')}<b>Real people</b><span>Message us on WhatsApp before or after you buy.</span></div>
    </div>
    <div class="chips" style="margin-top:28px"><a class="btn btn-primary" href="#shop">Browse units</a><a class="btn btn-secondary" href="#contact">Contact us</a></div>
  </article></div>`, 'guide');
}
function viewContact() {
  setView(`<div class="wrap"><article class="policy contact">
    <nav class="crumbs" aria-label="Breadcrumb"><a href="#home">Home</a>${icon('right')}<span>Contact</span></nav>
    <h1>Contact us</h1>
    <p class="draft"><b>Draft.</b> Fill in the highlighted items before the store goes live.</p>
    <p class="lead">Questions about a unit, delivery to your site or an order you placed? WhatsApp is the fastest way to reach us.</p>
    <a class="btn btn-wa" href="https://wa.me/${CONFIG.whatsapp}?text=${encodeURIComponent(`Hi ${CONFIG.brand}, `)}" target="_blank" rel="noopener"><svg class="wa-ic" aria-hidden="true"><use href="#i-wa"/></svg>Chat on WhatsApp</a>
    <div class="contact-card" style="margin-top:20px">
      <div class="contact-item"><svg class="icon wa-ic" aria-hidden="true"><use href="#i-wa"/></svg><div><small>WhatsApp, call or text</small><b>${esc(CONFIG.phone)}</b></div><button class="copy-btn" type="button" data-copy="${esc(CONFIG.phone)}">Copy</button></div>
      <div class="contact-item">${icon('mail')}<div><small>Email</small><b>${draftVal(CONFIG.email)}</b></div><button class="copy-btn" type="button" data-copy="${esc(CONFIG.email)}">Copy</button></div>
      <div class="contact-item">${icon('home')}<div><small>Business address</small><b>${esc(CONFIG.company)}<br>${esc(CONFIG.street)}<br>${esc(CONFIG.city)}, United States</b></div><a class="copy-btn map-btn" href="${MAP_URL}" target="_blank" rel="noopener">Map</a></div>
    </div>
    <h2>Send us a message</h2>
    <p>Fill this in and press the button. It opens WhatsApp with your message ready to send.</p>
    <form class="form-grid ct-form" id="ctForm" novalidate>
      <div class="fld h"><label for="ctName">Your name</label><input class="input" id="ctName" autocomplete="name"></div>
      <div class="fld h"><label for="ctZip">Delivery ZIP code <span class="opt-note">(optional)</span></label><input class="input" id="ctZip" inputmode="numeric" maxlength="10" autocomplete="postal-code"></div>
      <div class="fld"><label for="ctOrder">Order number <span class="opt-note">(if you have one)</span></label><input class="input" id="ctOrder" placeholder="BT-12345"></div>
      <div class="fld"><label for="ctMsg">Message</label><textarea class="input" id="ctMsg" rows="4" required placeholder="Which unit, how many, and where it is going"></textarea><span class="err-msg" id="ctMsg-err">Write a short message.</span></div>
      <button class="btn btn-primary" type="submit"><svg class="wa-ic" aria-hidden="true"><use href="#i-wa"/></svg>Send on WhatsApp</button>
    </form>
    <h2>Before you write</h2>
    <ul><li>About an order: have your order number ready (it is in your confirmation email).</li><li>About delivery: tell us your ZIP code and anything that could block a truck, such as gates, trees or soft ground.</li><li>Returns: see the <a href="#returns">Return policy</a>. Delivery: see <a href="#shipping">Shipping &amp; delivery</a>.</li></ul>
  </article></div>`, 'guide');
  $('#ctForm').addEventListener('submit', e => {
    e.preventDefault();
    const msg = $('#ctMsg');
    if (!validateField(msg)) { msg.focus(); return; }
    const v = id => $('#' + id).value.trim();
    const text = [`Hi ${CONFIG.brand}, ${v('ctMsg')}`, v('ctName') && `Name: ${v('ctName')}`, v('ctZip') && `ZIP: ${v('ctZip')}`, v('ctOrder') && `Order: ${v('ctOrder')}`].filter(Boolean).join('\n');
    window.open(`https://wa.me/${CONFIG.whatsapp}?text=${encodeURIComponent(text)}`, '_blank', 'noopener');
  });
}
const POLICIES = {
  returns: { title: 'Return policy', body: () => `
    <h2>40-day returns</h2>
    <p>You can return a container or trailer within 40 days of the delivery date for a refund of the price you paid, as long as it is in the same condition as when it was delivered.</p>
    <h2>What can be returned</h2>
    <ul><li>Units that have not been modified, painted, drilled, welded or damaged after delivery.</li>
      <li>Units that have not been used to store hazardous, food or waste materials.</li>
      <li>Units with all keys, lockboxes and accessories that came with them.</li></ul>
    <p>These cannot be returned: ${F_('custom-built or modified units? units sold "as-is"? confirm with supplier')}.</p>
    <h2>How to start a return</h2>
    <p>Email ${esc(CONFIG.email)} or call ${esc(CONFIG.phone)} with your order number and a few photos of the unit. We confirm the return and agree a pickup day with you.</p>
    <h2>Pickup and refund</h2>
    <p>Return pickup costs ${F_('free / a flat fee of $___ / the actual freight cost')}. The site must be reachable for the same type of truck that delivered the unit.</p>
    <p>After the unit is picked up and inspected, we refund the original payment method within ${F_('__')} business days.</p>
    <h2>Damage on delivery</h2>
    <p>Check the unit when it arrives. Note any damage on the delivery receipt and send us photos within 48 hours of delivery so we can repair, replace or refund it.</p>` },
  shipping: { title: 'Shipping & delivery', body: () => `
    <h2>Delivery is included</h2>
    <p>Every price on this site includes delivery to an address in ${F_('the 48 contiguous US states? confirm Alaska and Hawaii')}. There is no separate delivery charge at checkout.</p>
    <h2>When it arrives</h2>
    <p>After your order we contact you within ${F_('__ business days')} to agree a delivery day. Delivery usually takes about 20 days from the order date, depending on the unit and your location.</p>
    <h2>How containers are delivered</h2>
    <p>Containers arrive on a tilt-bed truck that slides the unit onto the ground. The site needs firm, level ground and a clear, straight approach of about ${F_('__ ft')} with open sky above. Tell us about gates, trees, overhead wires or soft ground when you order.</p>
    <h2>How trailers are delivered</h2>
    <p>Trailers are delivered to your address ${F_('by a driver / by carrier, confirm')}. Before towing, check that your vehicle and hitch are rated for the trailer's loaded weight.</p>
    <h2>If delivery cannot be completed</h2>
    <p>If the truck cannot reach the agreed spot or nobody is there, a re-delivery fee of ${F_('$___')} may apply.</p>` },
  privacy: { title: 'Privacy policy', body: () => `
    <p class="upd">Effective date: ${F_('date')}</p>
    <h2>Who we are</h2>
    <p>This store is operated by ${esc(CONFIG.company)}, ${esc(ADDRESS)}. Contact: ${esc(CONFIG.email)}.</p>
    <h2>What we collect</h2>
    <ul><li>Contact details: name, email, phone and company.</li><li>Delivery address and site notes you give us.</li><li>Order details: products, prices and payment status. Card numbers are handled by our payment provider and never stored by us.</li><li>Basic device and usage data from cookies, such as pages visited.</li></ul>
    <h2>How we use it</h2>
    <ul><li>To process and deliver your order and to contact you about it.</li><li>To answer quote requests and questions.</li><li>To keep records required by tax and accounting law.</li></ul>
    <h2>Who we share it with</h2>
    <p>Only with the companies needed to complete your order: our payment provider, our store platform, and the supplier and carrier that deliver your unit. We do not sell your personal information.</p>
    <h2>Your choices</h2>
    <p>You can ask to see, correct or delete your personal information by emailing ${esc(CONFIG.email)}. Residents of some states, such as California, have additional rights under state law.</p>` },
  terms: { title: 'Terms of sale', body: () => `
    <p class="upd">Effective date: ${F_('date')}</p>
    <h2>Seller</h2>
    <p>Products on this site are sold by ${esc(CONFIG.company)}, ${esc(ADDRESS)}.</p>
    <h2>Prices and payment</h2>
    <p>Prices are in US dollars and include delivery to the areas listed on the Shipping & delivery page. Sales tax is added at checkout where it applies. Payment is taken by card at checkout.</p>
    <h2>Orders</h2>
    <p>An order is accepted when we send the order confirmation email. If a unit is no longer available, we tell you and refund any payment in full.</p>
    <h2>Delivery and ownership</h2>
    <p>Ownership and risk of loss pass to you when the unit is delivered and the delivery receipt is signed.</p>
    <h2>Condition and warranty</h2>
    <p>Each unit is sold in the condition described on its product page (new / one-trip, cargo-worthy, wind & watertight, refurbished or as-is). Warranty: ${F_('none / manufacturer warranty for new trailers / __ days, confirm with supplier')}.</p>
    <h2>Returns</h2>
    <p>See the <a href="#returns">Return policy</a>.</p>
    <h2>Limitation of liability</h2>
    <p>Our liability for any claim related to a unit is limited to the price paid for that unit, to the extent the law allows.</p>
    <h2>Governing law</h2>
    <p>These terms are governed by the laws of the State of ${F_('state')}.</p>` },
};
function viewPolicy(key) {
  const pol = POLICIES[key];
  setView(`<div class="wrap"><article class="policy">
    <nav class="crumbs" aria-label="Breadcrumb"><a href="#home">Home</a>${icon('right')}<span>${esc(pol.title)}</span></nav>
    <h1>${esc(pol.title)}</h1>
    <p class="draft"><b>Draft.</b> Fill in the highlighted items and have the text reviewed before the store goes live.</p>
    ${pol.body()}
  </article></div>`, '');
}

function viewGuide() {
  setView(`<div class="wrap guide">
    <div><nav class="crumbs" aria-label="Breadcrumb"><a href="#home">Home</a>${icon('right')}<span>Buying guide</span></nav><h1 style="margin-top:6px">Buying guide &amp; help</h1></div>
    <section class="g-sec" aria-labelledby="gContact"><h2 id="gContact">Talk to us</h2><p>Not sure which unit fits? Send us the job and the site, and we'll suggest options. <a class="link" href="#contact">All contact options</a></p>
      <div class="contact-card">
        <div class="contact-item">${icon('phone')}<div><small>Call or text</small><b>${esc(CONFIG.phone)}</b></div><button class="copy-btn" type="button" data-copy="${esc(CONFIG.phone)}">Copy</button></div>
        <div class="contact-item">${icon('mail')}<div><small>Email</small><b>${esc(CONFIG.email)}</b></div><button class="copy-btn" type="button" data-copy="${esc(CONFIG.email)}">Copy</button></div>
      </div></section>
    <section class="g-sec" aria-labelledby="gSizes"><h2 id="gSizes">Container sizes</h2><p>Outside dimensions of common container sizes. Inside, walls take a few inches off each side.</p>
      <div style="margin-top:16px">${sizeStack()}</div>
      <div class="tbl-wrap"><table class="tbl"><thead><tr><th>Size</th><th>Length</th><th>Width</th><th>Height</th><th>Floor space (approx.)</th></tr></thead><tbody>
        <tr><td>10 ft standard</td><td>10 ft</td><td>8 ft</td><td>8 ft 6 in</td><td>70 sq ft</td></tr>
        <tr><td>20 ft standard</td><td>20 ft</td><td>8 ft</td><td>8 ft 6 in</td><td>150 sq ft</td></tr>
        <tr><td>20 ft high cube</td><td>20 ft</td><td>8 ft</td><td>9 ft 6 in</td><td>150 sq ft</td></tr>
        <tr><td>40 ft standard</td><td>40 ft</td><td>8 ft</td><td>8 ft 6 in</td><td>300 sq ft</td></tr>
        <tr><td>40 ft high cube</td><td>40 ft</td><td>8 ft</td><td>9 ft 6 in</td><td>300 sq ft</td></tr>
        <tr><td>45 ft high cube</td><td>45 ft</td><td>8 ft</td><td>9 ft 6 in</td><td>340 sq ft</td></tr>
        <tr><td>53 ft high cube</td><td>53 ft</td><td>8 ft 6 in</td><td>9 ft 6 in</td><td>420 sq ft</td></tr>
      </tbody></table></div></section>
    <section class="g-sec" aria-labelledby="gCond"><h2 id="gCond">Container condition</h2><p>Condition is the biggest price driver after size. <a class="link" href="#condition">Full condition guide</a></p>
      ${gradeStat()}${gradeCards()}</section>
    <section class="g-sec" aria-labelledby="gPay"><h2 id="gPay">Paying safely</h2><div style="margin-top:14px;max-width:720px">${payBox()}</div></section>
    <section class="g-sec" aria-labelledby="gTrl"><h2 id="gTrl">Choosing an enclosed trailer</h2><p>Width decides what fits inside; axles decide how much weight it can carry.</p>
      <div class="tbl-wrap"><table class="tbl"><thead><tr><th>Width</th><th>Good for</th><th>In stock</th></tr></thead><tbody>
        ${[[6, 'Mowers, tools, small moves'], [7, 'ATVs, landscaping and contractor gear'], [8.5, 'Cars, side-by-sides, wide equipment, mobile workshops']].map(([w, t]) => `<tr><td>${w} ft</td><td>${t}</td><td><a class="link" href="#shop" data-preset="${preset({ cat: 't', sel: { tw: [String(w)] } })}">${CAT.filter(p => p.W === w && p.c === 't').length} trailers</a></td></tr>`).join('')}
      </tbody></table></div>
      <div class="tbl-wrap"><table class="tbl"><thead><tr><th>Axles</th><th>Typical GVWR</th><th>In stock</th></tr></thead><tbody>
        <tr><td>Single 3,500 lb</td><td>About 3,500 lb</td><td><a class="link" href="#shop" data-preset="${preset({ cat: 't', sel: { axn: ['1'] } })}">${CAT.filter(p => p.axn === 1).length} trailers</a></td></tr>
        <tr><td>Tandem 3,500 lb</td><td>About 7,000 lb</td><td><a class="link" href="#shop" data-preset="${preset({ cat: 't', sel: { axn: ['2'], axr: ['3500'] } })}">${CAT.filter(p => p.axn === 2 && p.ax === 3500).length} trailers</a></td></tr>
        <tr><td>Tandem 5,200 lb</td><td>About 10,400 lb</td><td><a class="link" href="#shop" data-preset="${preset({ cat: 't', sel: { axn: ['2'], axr: ['5200'] } })}">${CAT.filter(p => p.axn === 2 && p.ax === 5200).length} trailers</a></td></tr>
        <tr><td>Tandem 7,000 lb</td><td>About 14,000 lb</td><td><a class="link" href="#shop" data-preset="${preset({ cat: 't', sel: { axn: ['2'], axr: ['7000'] } })}">${CAT.filter(p => p.axn === 2 && p.ax >= 7000).length} trailers</a></td></tr>
      </tbody></table></div>
      <p class="muted" style="margin-top:12px">GVWR is the trailer plus everything in it. Check that your tow vehicle is rated for at least that much.</p>
      <div class="grade">
        <div><b>V-nose</b><span>Pointed front for better airflow and extra room for tools up front.</span></div>
        <div><b>Flat nose</b><span>Square front, so every foot of length is usable floor.</span></div>
        <div><b>Gooseneck</b><span>Hitches in the truck bed. More stable for long, heavy trailers.</span></div>
        <div><b>Blackout package</b><span>Black trim and fenders instead of chrome. A look, not a structural change.</span></div>
      </div></section>
    <section class="g-sec" aria-labelledby="gSite"><h2 id="gSite">Getting your site ready</h2>
      <div class="grade">
        <div><b>Level, firm ground</b><span>Concrete, gravel or compacted soil. Doors on a container only close properly when it sits level.</span></div>
        <div><b>Room for the truck</b><span>Containers arrive on a tilt-bed truck that needs a long straight run and open sky. Tell us about gates, trees and wires.</span></div>
        <div><b>Door direction</b><span>Decide which way the doors should face before delivery day. Turning a container afterwards needs equipment.</span></div>
        <div><b>Local rules</b><span>Some cities and HOAs need a permit for containers on a property. Check before you order.</span></div>
      </div></section>
    <section class="g-sec" aria-labelledby="gFaq"><h2 id="gFaq">Questions buyers ask</h2><div style="margin-top:14px">${faq()}</div></section>
  </div>`, 'guide');
}

/* ---------- cart drawer ---------- */
const drawer = $('#drawer'), scrim = $('#scrim');
let lastFocus = null;
function openLayer(el) { lastFocus = document.activeElement; scrim.hidden = false; el.classList.add('open'); document.body.style.overflow = 'hidden'; setTimeout(() => (el.querySelector('[data-close], [data-close-filters], input, button') || el).focus(), 50); }
function closeLayers(refocus = true) {
  const wasOpen = !scrim.hidden;
  drawer.classList.remove('open'); $('#menu').classList.remove('open'); $('#filters')?.classList.remove('open');
  $('#modal').hidden = true; scrim.hidden = true; document.body.style.overflow = '';
  if (refocus && wasOpen && lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
}
function renderCart() {
  const body = $('#drBody'), foot = $('#drFoot');
  if (!cart.length) {
    body.innerHTML = `<div class="dr-empty">${icon('cart', 'icon')}<p>Your cart is empty.</p><a class="btn btn-primary" href="#shop" data-close>Browse units</a></div>`;
    foot.innerHTML = ''; return;
  }
  body.innerHTML = cart.map(l => { const p = BY.get(l.id); return `<div class="line">${thumb(p)}<div><a class="line-title" href="#p-${p.id}" data-close>${esc(p.st)}</a><div class="line-spec">${esc(cardSpec(p))}</div>
    <div class="line-row"><div class="qty sm"><button type="button" data-cq="${p.id}" data-d="-1" aria-label="Decrease quantity">${icon('minus')}</button><input type="number" inputmode="numeric" min="1" max="20" value="${l.qty}" data-cqi="${p.id}" aria-label="Quantity"><button type="button" data-cq="${p.id}" data-d="1" aria-label="Increase quantity">${icon('plus')}</button></div><b class="num">${money(p.p * l.qty)}</b></div>
    <button class="line-remove" type="button" data-remove="${p.id}">Remove</button></div></div>`; }).join('');
  foot.innerHTML = `<div class="sum-row"><span>Subtotal</span><b class="num">${money(cartTotal())}</b></div>
    <div class="sum-row"><span>Delivery</span><span>Included</span></div>
    <div class="cart-note"><label for="cartNote">Delivery notes <span class="opt-note">(optional)</span></label><textarea class="input" id="cartNote" rows="2" placeholder="Gate code, ground surface, where the doors should face">${esc(cartNote)}</textarea></div>
    <p class="sum-note">Sales tax, where it applies, is added at checkout.</p>
    <a class="btn btn-primary btn-block" href="#checkout" data-close data-cart-checkout>Checkout</a>
    <button class="btn btn-ghost btn-block" type="button" data-close>Keep shopping</button>`;
  hydrate(body);
}
let express = null; // "Buy now": check out one unit on its own and leave the cart as it is (Shopify's dynamic checkout does the same)
function buyNow(id, qty = 1) { // Shopify cart link: checkout with this unit only
  location.href = `${BASE}/cart/${BY.get(id).v}:${qty}`;
}
function addToCart(id, qty = 1) {
  const l = cart.find(x => x.id === id);
  if (l) l.qty = Math.min(20, l.qty + qty); else cart.push({ id, qty });
  syncCounts(); renderCart();
  const v = BY.get(id).v; cartSent.add(v);
  cartOp(() => cartReq('add', { items: [{ id: v, quantity: qty }] }).then(() => cartReq('')));
  const p = BY.get(id);
  toast(`<span>Added <b>${esc(p.st)}</b></span><button class="link" type="button" data-open-cart>View cart</button>`);
}
let toastT;
function toast(html) { const t = $('#toast'); t.innerHTML = html; t.classList.add('show'); clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('show'), 3200); }

/* ---------- compare tray ---------- */
function renderTray() {
  const tray = $('#cmpTray');
  const show = compare.length && currentRoute() === 'shop';
  tray.hidden = !show;
  if (!show) return;
  tray.innerHTML = `<span class="thumbs">${compare.map(id => thumb(BY.get(id))).join('')}</span>
    <a class="btn btn-primary" href="#compare">Compare ${compare.length}</a>
    <button class="x" type="button" data-cmp-clear aria-label="Clear compare list">${icon('x')}</button>`;
  hydrate(tray);
}
function toggleCompare(id, on) {
  const has = compare.includes(id);
  if (on && !has) {
    if (compare.length >= 4) { toast('<span>You can compare up to 4 units. Remove one first.</span>'); $$(`[data-cmp="${id}"]`).forEach(i => { i.checked = false; }); return; }
    compare.push(id);
  } else if (!on && has) compare = compare.filter(x => x !== id);
  $$(`[data-cmp="${id}"]`).forEach(i => { i.checked = compare.includes(id); });
  $$(`[data-cmp-toggle="${id}"]`).forEach(b => { b.textContent = compare.includes(id) ? 'Remove from compare' : 'Add to compare'; });
  saveCompare();
}

/* ---------- quote modal ---------- */
function openQuote(id) {
  const p = BY.get(id);
  $('#modalCard').innerHTML = `<button class="icon-btn x" type="button" data-close aria-label="Close">${icon('x')}</button>
    <h2 id="mdTitle">Request a quote</h2>
    <p class="muted" style="margin-top:6px">For several units, a fleet, or a custom fit-out of <b>${esc(p.st)}</b>.</p>
    <form id="quoteForm" class="form-grid" style="margin-top:16px" novalidate>
      <div class="fld h"><label for="qName">Name</label><input class="input" id="qName" autocomplete="name" required><span class="err-msg" id="qName-err">Fill in this field.</span></div>
      <div class="fld h"><label for="qCompany">Company <span class="opt-note">(optional)</span></label><input class="input" id="qCompany" autocomplete="organization"></div>
      <div class="fld h"><label for="email">Email</label><input class="input" id="email" type="email" autocomplete="email" required><span class="err-msg" id="email-err">Enter an email address like name@company.com.</span></div>
      <div class="fld h"><label for="qPhone">Phone <span class="opt-note">(optional)</span></label><input class="input" id="qPhone" type="tel" autocomplete="tel"></div>
      <div class="fld t"><label for="qQty">Quantity</label><input class="input" id="qQty" type="number" min="1" value="2" inputmode="numeric"></div>
      <div class="fld t"><label for="zip">Delivery ZIP</label><input class="input" id="zip" inputmode="numeric" autocomplete="postal-code" maxlength="10" required value="${esc(zipSaved)}"><span class="err-msg" id="zip-err">Enter a 5-digit ZIP code.</span></div>
      <div class="fld t"><label for="qWhen">Needed by</label><select class="input" id="qWhen"><option>No rush</option><option>Within 2 weeks</option><option>Within a month</option></select></div>
      <div class="fld"><label for="qMsg">Anything else? <span class="opt-note">(optional)</span></label><textarea class="input" id="qMsg" rows="3" placeholder="Modifications, colors, site details"></textarea></div>
      <div class="fld"><button class="btn btn-primary btn-block" type="submit">Send quote request</button></div>
    </form>`;
  $('#modal').hidden = false; scrim.hidden = false; lastFocus = document.activeElement; document.body.style.overflow = 'hidden';
  setTimeout(() => $('#qName').focus(), 30);
  $('#quoteForm').addEventListener('submit', e => {
    e.preventDefault();
    const bad = ['qName', 'email', 'zip'].map(i => $('#' + i)).filter(el => !validateField(el));
    if (bad.length) { bad[0].focus(); return; }
    const name = $('#qName').value.trim().split(' ')[0];
    $('#modalCard').innerHTML = `<button class="icon-btn x" type="button" data-close aria-label="Close">${icon('x')}</button>
      <div class="confirm-badge">${icon('check')}</div><h2 id="mdTitle" style="margin-top:14px">Thanks, ${esc(name)}.</h2>
      <p class="muted" style="margin-top:8px">In the live store this request goes straight to the sales team, who reply with a price for ${esc($('#qQty')?.value || 2)} units including delivery.</p>
      <button class="btn btn-primary btn-block" type="button" data-close style="margin-top:18px">Done</button>`;
  });
}


/* ---------- category menu ---------- */
function renderMenu() {
  const link = (label, pr, n, cls = '') => `<a class="mn-link ${cls}" href="#shop" data-preset="${preset(pr)}"><span>${esc(label)}</span><small>${n}</small></a>`;
  const cnt = test => CAT.filter(test).length;
  const cGroups = Object.entries(CGROUPS).map(([k, l]) => link(l, { cat: 'c', sel: { group: [k] } }, cnt(p => p.g === k))).join('');
  const tUses = Object.entries(TGROUPS).map(([k, l]) => link(l, { cat: 't', sel: { use: [k] } }, cnt(p => p.c === 't' && p.u.includes(k)))).join('');
  const cSizes = [['10', '10 ft'], ['20', '20 ft'], ['40', '40 ft'], ['45', '45 ft'], ['53', '53 ft']].map(([k, l]) => `<a class="chip" href="#shop" data-preset="${preset({ cat: 'c', sel: { clen: [k] } })}">${l}</a>`).join('');
  const tSizes = [['6', '6 ft wide'], ['7', '7 ft wide'], ['8.5', '8.5 ft wide']].map(([k, l]) => `<a class="chip" href="#shop" data-preset="${preset({ cat: 't', sel: { tw: [k] } })}">${l}</a>`).join('');
  $('#mnBody').innerHTML = `
    <div class="mn-group">${link('All products', { cat: 'all' }, CAT.length, 'all')}</div>
    <div class="mn-group"><h3>Containers</h3>${link('All containers', { cat: 'c' }, cnt(p => p.c === 'c'), 'all')}${cGroups}<div class="mn-sizes">${cSizes}</div></div>
    <div class="mn-group"><h3>Enclosed trailers</h3>${link('All trailers', { cat: 't' }, cnt(p => p.c === 't'), 'all')}${tUses}<div class="mn-sizes">${tSizes}</div></div>
    <div class="mn-group"><h3>Help</h3><a class="mn-link" href="#guide"><span>Buying guide</span></a><a class="mn-link" href="#condition"><span>Container condition</span></a><a class="mn-link" href="#about"><span>About us</span></a><a class="mn-link" href="#contact"><span>Contact</span></a><a class="mn-link" href="#compare"><span>Compare</span></a><a class="mn-link" href="#returns"><span>Returns</span></a><a class="mn-link" href="#shipping"><span>Shipping &amp; delivery</span></a></div>`;
}

/* ---------- search box ---------- */
const qIn = $('#q'), sug = $('#suggest'), qClear = $('#qClear');
let sugIdx = -1, sugT;
function renderSuggest() {
  const q = qIn.value.trim();
  qClear.hidden = !q;
  if (q.length < 2) { sug.hidden = true; qIn.setAttribute('aria-expanded', 'false'); return; }
  const S = searchCat(q);
  const hits = S.toks.length ? CAT.filter(p => S.scores.has(p.id)).map(p => [p, S.scores.get(p.id)]).sort((a, b) => b[1] - a[1] || a[0].r - b[0].r) : [];
  const note = searchNote(q, S);
  sugIdx = -1;
  sug.innerHTML = hits.length
    ? (note ? `<div class="sg-note">${note}</div>` : '') + hits.slice(0, 6).map(([p], i) => `<a class="sg-item" role="option" id="sg${i}" href="#p-${p.id}" aria-selected="false">${thumb(p)}<span><span class="sg-title">${esc(p.st)}</span><span class="sg-spec">${esc(cardSpec(p))}</span></span><span class="sg-price num">${money(p.p)}</span></a>`).join('') +
      `<button class="sg-all" type="button" data-search-all>See all ${hits.length} results for “${esc(S.fixedQ || q)}”</button>`
    : `<div class="sg-empty">No matches for “${esc(q)}”. Try “20 ft”, “reefer” or “car hauler”.</div>`;
  sug.hidden = false; qIn.setAttribute('aria-expanded', 'true');
  hydrate(sug);
}
function runSearch() {
  const q = qIn.value.trim();
  sug.hidden = true; qIn.setAttribute('aria-expanded', 'false');
  applyPreset({ q });
  qIn.blur();
  go('shop');
}
qIn.addEventListener('input', () => { clearTimeout(sugT); sugT = setTimeout(renderSuggest, 60); });
qIn.addEventListener('focus', () => { if (qIn.value.trim().length >= 2) renderSuggest(); });
qIn.addEventListener('keydown', e => {
  const items = $$('.sg-item', sug);
  if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
    if (!items.length) return; e.preventDefault();
    sugIdx = (sugIdx + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
    items.forEach((it, i) => it.setAttribute('aria-selected', String(i === sugIdx)));
    qIn.setAttribute('aria-activedescendant', 'sg' + sugIdx);
  } else if (e.key === 'Enter') {
    e.preventDefault();
    if (sugIdx >= 0 && items[sugIdx]) { sug.hidden = true; fixLink(items[sugIdx]); navigateHref(items[sugIdx].getAttribute('href')); }
    else if (qIn.value.trim()) runSearch();
  } else if (e.key === 'Escape') { sug.hidden = true; qIn.setAttribute('aria-expanded', 'false'); }
});
qClear.addEventListener('click', () => { qIn.value = ''; renderSuggest(); qIn.focus(); if (F.q && currentRoute() === 'shop') { F.q = ''; viewShop(); } });
document.addEventListener('click', e => { if (!e.target.closest('.search')) sug.hidden = true; });

/* ---------- global events ---------- */
document.addEventListener('click', e => {
  const t = e.target;
  const pre = t.closest('[data-preset]');
  if (pre) {
    applyPreset(JSON.parse(pre.dataset.preset));
    if (currentRoute() === 'shop') { e.preventDefault(); closeLayers(false); viewShop(); window.scrollTo(0, 0); }
    return;
  }
  const add = t.closest('[data-add]');
  if (add) { e.preventDefault(); const qf = add.dataset.qtyFrom && $('#' + add.dataset.qtyFrom); addToCart(+add.dataset.add, qf ? Math.max(1, Math.min(20, parseInt(qf.value, 10) || 1)) : 1); return; }
  const buy = t.closest('[data-buy]');
  if (buy) { e.preventDefault(); const qf = buy.dataset.qtyFrom && $('#' + buy.dataset.qtyFrom); buyNow(+buy.dataset.buy, qf ? Math.max(1, Math.min(20, parseInt(qf.value, 10) || 1)) : 1); return; }
  if (t.closest('[data-cart-checkout]')) { e.preventDefault(); goCheckout(); return; }
  if (t.closest('[data-open-menu]')) { e.preventDefault(); closeLayers(); openLayer($('#menu')); return; }
  if (t.closest('[data-open-cart]')) { e.preventDefault(); closeLayers(); renderCart(); openLayer(drawer); $('#toast').classList.remove('show'); return; }
  if (t.closest('[data-close]')) { closeLayers(); return; }
  if (t === scrim) { closeLayers(); return; }
  const cq = t.closest('[data-cq]');
  if (cq) { const l = cart.find(x => x.id === +cq.dataset.cq); if (l) { l.qty = Math.max(1, Math.min(20, l.qty + +cq.dataset.d)); saveCart(); renderCart(); } return; }
  const rm = t.closest('[data-remove]');
  if (rm) { cart = cart.filter(x => x.id !== +rm.dataset.remove); saveCart(); renderCart(); return; }
  const ct = t.closest('[data-cmp-toggle]');
  if (ct) {
    const id = +ct.dataset.cmpToggle, on = !compare.includes(id);
    toggleCompare(id, on);
    if (on && compare.includes(id)) toast(`<span>Added to compare (${compare.length} of 4)</span><a class="link" href="#compare">Compare now</a>`);
    return;
  }
  const q = t.closest('[data-quote]');
  if (q) { openQuote(+q.dataset.quote); return; }
  const qs = t.closest('[data-qstep]');
  if (qs) { const i = $('#pQty'); i.value = Math.max(1, Math.min(20, (parseInt(i.value, 10) || 1) + +qs.dataset.qstep)); return; }
  const gs = t.closest('[data-gstep]'); if (gs) { stepGallery(+gs.dataset.gstep); return; }
  if (t.closest('[data-lb-close]')) { closeLightbox(); return; }
  const ls = t.closest('[data-lb-step]'); if (ls) { lbShow(lbI + +ls.dataset.lbStep); return; }
  const lg = t.closest('[data-lb-go]'); if (lg) { lbShow(+lg.dataset.lbGo); return; }
  if (t.closest('[data-lb-open]') || t.closest('.g-slide')) {
    const tr = $('#gTrack'); const k = tr ? Math.round(tr.scrollLeft / tr.clientWidth) : 0;
    openLightbox(BY.get(+curKey.slice(2)), k); return;
  }
  const gt = t.closest('[data-g]'); if (gt) { stepGallery(0, +gt.dataset.g); return; }
  if (t.closest('[data-uncmp]')) { toggleCompare(+t.closest('[data-uncmp]').dataset.uncmp, false); viewCompare(); return; }
  if (t.closest('[data-cmp-clear]')) { compare = []; $$('[data-cmp]').forEach(i => { i.checked = false; }); saveCompare(); return; }
  if (t.closest('[data-search-all]')) { runSearch(); return; }
  const cp = t.closest('[data-copy]');
  if (cp) {
    const txt = cp.dataset.copy;
    const done = () => { cp.textContent = 'Copied'; setTimeout(() => { cp.textContent = 'Copy'; }, 1600); };
    const fallback = () => { const b = cp.parentElement.querySelector('b'); const r = document.createRange(); r.selectNodeContents(b); const s = getSelection(); s.removeAllRanges(); s.addRange(r); cp.textContent = 'Selected'; };
    try { navigator.clipboard.writeText(txt).then(done, fallback); } catch { fallback(); }
    return;
  }
  // shop controls
  if (currentRoute() !== 'shop') return;
  const chip = t.closest('[data-chip]');
  if (chip && !chip.disabled) {
    toggleSel(chip.dataset.chip, chip.value); shown = 24; chip.setAttribute('aria-pressed', String(F.sel[chip.dataset.chip].has(chip.value))); refreshShop(); return;
  }
  const tab = t.closest('[data-cat]');
  if (tab) { F.cat = tab.dataset.cat; F.sel = F.sel.job ? { job: F.sel.job } : {}; shown = 24; viewShop(); window.scrollTo(0, 0); return; }
  const un = t.closest('[data-unsel]');
  if (un) {
    F.sel[un.dataset.unsel]?.delete(un.value); shown = 24;
    if (un.dataset.unsel === 'job') { viewShop(); return; }
    const box = view.querySelector(`[data-opt="${un.dataset.unsel}|${CSS.escape(un.value)}"]`);
    if (box) { const inp = box.querySelector('input'); if (inp) inp.checked = false; else box.setAttribute('aria-pressed', 'false'); }
    refreshShop(); return;
  }
  if (t.closest('[data-unq]')) { F.q = ''; qIn.value = ''; viewShop(); return; }
  if (t.closest('[data-clear]')) { const c = F.cat; F = newFilters(c); qIn.value = ''; shown = 24; closeLayers(); viewShop(); return; }
  if (t.closest('[data-more]')) { shown += 24; refreshShop(); return; }
  if (t.closest('#fOpen')) { openLayer($('#filters')); return; }
  if (t.closest('[data-close-filters]')) { closeLayers(); return; }
});
document.addEventListener('change', e => {
  const t = e.target;
  if (t.matches('[data-cmp]')) { toggleCompare(+t.dataset.cmp, t.checked); return; }
  if (t.matches('[data-cqi]')) { const l = cart.find(x => x.id === +t.dataset.cqi); if (l) { l.qty = Math.max(1, Math.min(20, parseInt(t.value, 10) || 1)); saveCart(); renderCart(); } return; }
  if (t.matches('[data-facet]')) { toggleSel(t.dataset.facet, t.value); shown = 24; refreshShop(); return; }
  if (t.id === 'sort') { sortKey = t.value; shown = 24; refreshShop(); return; }
});
document.addEventListener('input', e => {
  if (e.target.id === 'cartNote') { cartNote = e.target.value.slice(0, 500); clearTimeout(noteT); noteT = setTimeout(noteSave, 700); }
});
document.addEventListener('submit', e => {
  if (e.target.matches('form:not(#coForm):not(#quoteForm):not(#finder)')) e.preventDefault();
});
document.addEventListener('keydown', e => { if (e.key === 'Escape' && !scrim.hidden) closeLayers(); });

/* ---------- Shopify cart ---------- */
const BYV = new Map(CAT.map(p => [p.v, p]));
let cartPend = 0, cartQ = Promise.resolve(), noteT = null;
function cartReq(path, body) {
  const url = BASE + (path ? '/cart/' + path + '.js' : '/cart.js');
  return fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
    .then(r => { if (!r.ok) throw new Error(r.status); return r.json(); });
}
function takeCart(c) {
  const next = [];
  for (const it of c.items || []) {
    const p = BYV.get(it.variant_id); if (!p) continue;
    const l = next.find(x => x.id === p.id);
    if (l) l.qty += it.quantity; else next.push({ id: p.id, qty: it.quantity });
  }
  cart = next;
  if (document.activeElement?.id !== 'cartNote') cartNote = c.note || '';
  syncCounts();
  if (drawer.classList.contains('open') && !drawer.contains(document.activeElement)) renderCart();
}
function cartOp(fn) { // one request at a time; the server's answer replaces the local copy once nothing else is waiting
  cartPend++;
  cartQ = cartQ.then(fn).then(c => { if (--cartPend === 0 && c) takeCart(c); })
    .catch(() => { cartPend--; toast('<span>The cart could not be updated. Check your connection and try again.</span>'); cartReq('').then(takeCart).catch(() => {}); });
  return cartQ;
}
function saveCart() { // quantities changed or a line was removed
  syncCounts();
  const updates = {};
  for (const p of BYV.values()) if (cartSent.has(p.v)) updates[p.v] = 0;
  for (const l of cart) updates[BY.get(l.id).v] = l.qty;
  cartOp(() => cartReq('update', { updates }));
}
let cartSent = new Set(); // variants the server cart may hold
function noteSave() { clearTimeout(noteT); noteT = null; const note = cartNote; return cartOp(() => cartReq('update', { note })); }
function goCheckout() { closeLayers(false); (noteT ? noteSave() : cartQ).finally(() => { location.href = BASE + '/checkout'; }); }

/* ---------- routing: Shopify addresses ---------- */
const PAGE_KEYS = ["guide", "condition", "about", "contact", "compare"];
const POLICY = {"returns": "refund-policy", "shipping": "shipping-policy", "privacy": "privacy-policy", "terms": "terms-of-service"}; // these open Shopify's policy pages (Settings > Policies), not the app's own drafts
const COLL = {"all": {"cat": "all"}, "containers": {"cat": "c"}, "trailers": {"cat": "t"}, "storage-containers": {"cat": "c", "sel": {"group": ["storage"]}}, "refrigerated-containers": {"cat": "c", "sel": {"group": ["cold"]}}, "offices-site-cabins": {"cat": "c", "sel": {"group": ["office"]}}, "bars-cafes-kiosks": {"cat": "c", "sel": {"group": ["business"]}}, "toilets-welfare-units": {"cat": "c", "sel": {"group": ["welfare"]}}, "hazmat-secure-stores": {"cat": "c", "sel": {"group": ["hazmat"]}}, "container-pools": {"cat": "c", "sel": {"group": ["pool"]}}, "flat-pack-stores": {"cat": "c", "sel": {"group": ["flatpack"]}}, "specialty-units": {"cat": "c", "sel": {"group": ["other"]}}, "cargo-trailers": {"cat": "t", "sel": {"use": ["cargo"]}}, "car-haulers": {"cat": "t", "sel": {"use": ["car"]}}, "motorcycle-atv-trailers": {"cat": "t", "sel": {"use": ["moto"]}}, "landscaping-trailers": {"cat": "t", "sel": {"use": ["lawn"]}}, "event-trailers": {"cat": "t", "sel": {"use": ["event"]}}};
const BASE = (BT.root || '/').replace(/\/$/, '');
const BYH = new Map(CAT.map(p => [p.h, p]));
let curKey = 'home', lastShopPath = BASE + '/collections/all';
function presetPath(pr) {
  if (pr.q) return BASE + '/search?q=' + encodeURIComponent(pr.q);
  const s = JSON.stringify(pr);
  for (const [k, v] of Object.entries(COLL)) if (JSON.stringify(v) === s) return BASE + '/collections/' + k;
  return BASE + '/collections/' + (pr.cat === 'c' ? 'containers' : pr.cat === 't' ? 'trailers' : 'all');
}
function keyToPath(h) {
  if (!h || h === 'home') return BASE + '/';
  if (h === 'shop') return F.q ? presetPath({ q: F.q }) : lastShopPath;
  if (h === 'containers' || h === 'trailers') return BASE + '/collections/' + h;
  if (h.startsWith('p-')) { const p = BY.get(+h.slice(2)); return p ? BASE + '/products/' + p.h : BASE + '/'; }
  if (h === 'checkout') return BASE + '/checkout';
  if (POLICY[h]) return BASE + '/policies/' + POLICY[h];
  if (PAGE_KEYS.includes(h)) return BASE + '/pages/' + h;
  return null;
}
function parseLoc(url) { // which view an address shows; null = a Shopify page this app leaves alone (cart, account, policies...)
  const u = new URL(url || location.href, location.href);
  if (u.origin !== location.origin) return null;
  let path = decodeURIComponent(u.pathname);
  if (BASE && path.startsWith(BASE)) path = path.slice(BASE.length);
  path = path.replace(/\/+$/, '') || '/';
  let m;
  if (path === '/') return { key: 'home' };
  if ((m = /^\/(?:collections\/[^/]+\/)?products\/([^/]+)$/.exec(path))) { const p = BYH.get(m[1]); return { key: p ? 'p-' + p.id : 'p-0' }; }
  if ((m = /^\/collections\/([^/]+)$/.exec(path))) return { key: 'shop', preset: COLL[m[1]] || { cat: 'all' } };
  if (path === '/collections') return { key: 'shop', preset: { cat: 'all' } };
  if (path === '/search') return { key: 'shop', preset: { cat: 'all', q: u.searchParams.get('q') || '' } };
  if ((m = /^\/pages\/([^/]+)$/.exec(path)) && PAGE_KEYS.includes(m[1])) return { key: m[1] };
  return null;
}
const SPA = !!parseLoc() && document.body.hasAttribute('data-spa');
function currentRoute() { return curKey.startsWith('p-') ? 'product' : curKey; }
function collNow() { // the Shopify collection being shown, while the filters are still that collection's own
  const m = /^\/collections\/([^/]+)$/.exec(location.pathname.slice(BASE.length));
  const c = m && BT.colls && BT.colls[m[1]], pr = m && COLL[m[1]];
  if (!c || !pr || F.q || F.cat !== pr.cat) return null;
  const want = JSON.stringify(pr.sel || {}), have = JSON.stringify(Object.fromEntries(Object.entries(F.sel).filter(([, v]) => v.size).map(([k, v]) => [k, [...v]])));
  return want === have ? c : null;
}
function go(h) {
  const path = keyToPath(h);
  if (!SPA || path == null) { if (path) location.href = path; return; }
  if (h === 'checkout') { location.href = path; return; }
  history.pushState({ app: 1 }, '', path);
  route({ keep: true });
}
function titleFor(key) {
  if (key.startsWith('p-')) { const p = BY.get(+key.slice(2)); return p ? `${p.seo || p.st} | ${CONFIG.brand}` : `Unit not found | ${CONFIG.brand}`; }
  if (key === 'shop') { const c = collNow(); return `${c ? c.t : F.q ? `Search: ${F.q}` : catLabel(F.cat)} | ${CONFIG.brand}`; }
  if (key === 'home') return `${CONFIG.brand} | Shipping containers and enclosed trailers, delivery included`;
  return `${{"guide": "Buying guide", "condition": "Container condition", "about": "About us", "contact": "Contact us", "compare": "Compare units", "returns": "Returns", "shipping": "Shipping & delivery", "privacy": "Privacy", "terms": "Terms of sale"}[key] || CONFIG.brand} | ${CONFIG.brand}`;
}
let prevRoute = null;
function route(opts = {}) {
  closeLayers(false);
  if (!$('#lb').hidden) closeLightbox();
  sug.hidden = true;
  const L = parseLoc();
  if (!L) return;
  const from = prevRoute;
  if (from === 'shop') shopScroll = window.scrollY;
  curKey = L.key;
  if (L.key === 'shop') {
    if (!opts.keep) { applyPreset(L.preset); qIn.value = L.preset.q || ''; }
    if (!F.q) lastShopPath = location.pathname;
    viewShop();
  } else if (L.key.startsWith('p-')) viewProduct(+L.key.slice(2));
  else ({ home: viewHome, compare: viewCompare, guide: viewGuide, condition: viewCondition, about: viewAbout, contact: viewContact, returns: () => viewPolicy('returns'), shipping: () => viewPolicy('shipping'), privacy: () => viewPolicy('privacy'), terms: () => viewPolicy('terms') }[L.key] || viewHome)();
  const r = currentRoute();
  document.body.dataset.route = r;
  document.title = titleFor(L.key);
  if (r === 'shop' && from === 'product' && shopScroll) { const y = shopScroll; requestAnimationFrame(() => window.scrollTo(0, y)); }
  else if (!opts.noScroll) window.scrollTo(0, 0);
  prevRoute = r;
  renderTray();
}
window.addEventListener('popstate', e => { if (SPA) route({ keep: !!(e.state && e.state.app) && parseLoc()?.key === 'shop' && prevRoute !== 'shop' }); });

/* hash links written by the views ("#p-123", "#shop") get real addresses */
function fixLink(a) {
  const raw = a.getAttribute('href');
  if (!raw || raw[0] !== '#' || raw.startsWith('#i-')) return;
  const key = raw.slice(1);
  if (a.hasAttribute('data-preset')) { try { a.setAttribute('href', presetPath(JSON.parse(a.dataset.preset))); return; } catch { /* keep */ } }
  if (key === 'shop') { a.dataset.shopBack = '1'; a.setAttribute('href', lastShopPath); return; }
  const path = keyToPath(key);
  if (path) a.setAttribute('href', path);
}
function fixLinks(root) { if (root.nodeType !== 1) return; if (root.matches('a[href^="#"]')) fixLink(root); root.querySelectorAll('a[href^="#"]').forEach(fixLink); }
new MutationObserver(ms => { for (const m of ms) m.addedNodes.forEach(fixLinks); }).observe(document.body, { childList: true, subtree: true });
fixLinks(document.body);
function navigateHref(href, opts = {}) {
  const L = parseLoc(href);
  if (!SPA || !L) { location.href = href; return; }
  history.pushState({ app: 1 }, '', new URL(href, location.href).pathname + new URL(href, location.href).search);
  route(opts);
}
document.addEventListener('click', e => { // runs after the app's own click handler (presets are applied by then)
  const a = e.target.closest('a[href]');
  if (!a || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === '_blank' || a.hasAttribute('download')) return;
  let href = a.getAttribute('href');
  if (href[0] === '#') { fixLink(a); href = a.getAttribute('href'); if (href[0] === '#') return; }
  if (a.dataset.shopBack) href = lastShopPath;
  const L = parseLoc(href);
  if (!SPA || !L) return; // normal page load
  if (e.defaultPrevented) { // the shop re-rendered itself for a preset link: just update the address
    if (a.hasAttribute('data-preset')) { history.pushState({ app: 1 }, '', href); if (!F.q) lastShopPath = new URL(href, location.href).pathname; document.title = titleFor('shop'); }
    return;
  }
  e.preventDefault();
  navigateHref(href, { keep: a.hasAttribute('data-preset') || !!a.dataset.shopBack });
});

/* ---------- boot ---------- */
$$('[data-brand]').forEach(el => { el.textContent = CONFIG.brand; });
$$('[data-phone]').forEach(el => { el.textContent = CONFIG.phone; });
$$('[data-email]').forEach(el => { el.textContent = CONFIG.email; });
$$('[data-address]').forEach(el => { el.innerHTML = `${esc(CONFIG.company)}<br>${esc(CONFIG.street)}<br>${esc(CONFIG.city)}`; });
if (matchMedia('(max-width: 599px)').matches) qIn.placeholder = 'Search';
const hdr = $('#hdr');
const setHdr = () => document.documentElement.style.setProperty('--hdr-h', hdr.offsetHeight + 'px');
if ('ResizeObserver' in window) new ResizeObserver(setHdr).observe(hdr); setHdr();
syncCounts();
renderMenu();
renderCart();
if (SPA) route({ noScroll: !!location.hash });
cartReq('').then(c => { cartSent = new Set((c.items || []).map(i => i.variant_id)); takeCart(c); }).catch(() => {});
})();
